<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                            <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                <label for="sbsituacao">Situação:</label>
                                <select name="sbsituacao" class="form-control form-control-sm selectpicker" id="sbsituacao" multiple data-actions-box="true" @change="mtdlimpar_listagem()">
                                    <option data-content="<span class='badge badge-primary bdg-digitacao'>Em digitação</span>" value="0"></option>
                                    <option data-content="<span class='badge badge-primary bdg-enviada'>Enviadas</span>" value="1"></option>
                                    <option data-content="<span class='badge badge-primary bdg-autorizada'>Autorizadas</span>" value="2"></option>
                                    <option data-content="<span class='badge badge-primary bdg-cancelada'>Canceladas</span>" value="3"></option>
                                    <option data-content="<span class='badge badge-primary bdg-denegada'>Denegadas</span>" value="4"></option>
                                    <option data-content="<span class='badge badge-primary bdg-inutilizada'>Inutilizadas</span>" value="5"></option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="ednnfpesq">Número da NF:</label>
                                <input id="ednnfpesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pnnf" @keyup="mtdlimpar_listagem()">
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpdestinatariopesq">Tp. Destinatário:</label>
                                <select name="cbtpdestinatario" class="form-control form-control-sm" id="cbtpdestinatariopesq" v-model="ptpdestinatario" @change="mtddefselect2destinatariopesq()">
                                    <option value="0">Cliente</option>
                                    <option value="1">Fornecedor</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Destinatário:</span>
								<select id="cbdestinatariopesq" data-placeholder="Selecione um destinatário" v-model="piddestinatario" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Modelo:</label>
                                <select name="cbmodelopesq" class="form-control form-control-sm" id="cbmodelopesq" v-model="pmodelo" @change="mtdlimpar_listagem()">
                                    <option value="55">55 - NF-e</option>
                                    <option value="65">65 - NFC-e</option>
                                    <option value="99">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Natureza de operação:</span>
                                <select id="cbnatoppesq" data-placeholder="Selecione um registro" v-model="pidnatop" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                             
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edseriepesq">Série:</label>
                                <input id="edseriepesq" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="pserie" @keyup="mtdlimpar_listagem()">
                            </div>                                                                                 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstnotasfiscais"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_nnf" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.nnf, 8) }}
                                    </template>
                                    <template slot="slot_situacaonota" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacaonota) === 0" class="badge badge-primary bdg-digitacao">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 1" class="badge badge-primary bdg-enviada">Enviada</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 2" class="badge badge-primary bdg-autorizada">Autorizada</span>
                                        <span v-else-if="parseInt(item.row.situacaonota) === 3" class="badge badge-primary bdg-cancelada">Cancelada</span>
                                        <span v-else class="badge badge-primary bdg-denegada">Denegada</span>
                                    </template>                                                                        
                                    <template slot="slot_serie" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.serie, 3) }}
                                    </template> 
                                    <template slot="slot_dthremissao" slot-scope="item">
                                        {{ item.row.dthremissao }}
                                    </template> 
                                    <template slot="slot_valor" slot-scope="item">
                                        {{ mtdformatavalordecimal(parseFloat(item.row.vnf), 2) }}
                                    </template>
                                    <template slot="slot_xmotivo" slot-scope="item">
                                        {{ item.row.xmotivo }}
                                    </template>
                                    <template slot="slot_chave" slot-scope="item">
                                        <span style="font-size: 12px; color: #6c757d; font-weight: bold;">{{ item.row.chave }}</span>
                                    </template>                                                                                                                                                                                
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <span>Totalizadores <span class="badge badge-info badge-pill">{{lstnotasfiscais.length}}</span></span>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(ptotalnotas), 2)}}</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="lstinutilizacoes.length > 0" class="col-lg-12" style="margin-top: 10px;">
                                <div class="table-responsive">
                                    <table id="tblistainut" class="table table-bordered table-striped table-sm table-hover">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th width="50px" style="text-align: center;">Id.:</th>
                                            <th>Filial:</th>                                                            
                                            <th>Emissão:</th>                                                            
                                            <th>Modelo:</th>
                                            <th>Série:</th>
                                            <th>Faixa de inutilização:</th>
                                            <th>Motivo:</th>
                                        </tr>
                                        </thead>
                                        <tbody id="lstinut">
                                            <tr v-for="(inutilizacao, index) in lstinutilizacoes" v-bind:key="index">
                                                <td style="text-align: center;">{{ mtdformatarzeros(inutilizacao.id, 4) }}</td> 
                                                <td>{{ inutilizacao.fantasia }}</td>
                                                <td>{{ inutilizacao.dthremissao }}</td>
                                                <td v-if="parseInt(inutilizacao.nmodelo) === 55">55 NF-e</td>
                                                <td v-else>65 NFC-e</td>
                                                <td>{{ inutilizacao.nserie }}</td>
                                                <td>{{ mtdformatarzeros(inutilizacao.nini, 8) }} - {{ mtdformatarzeros(inutilizacao.nfim, 8) }}</td>
                                                <td>{{ inutilizacao.xjust }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="lstinutilizacoes.length > 0" class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Quantidade de inutilizações
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="background-color: #f82b54;">{{lstinutilizacoes.length}}</span>
                                    </li>
                                </ul>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="dropdown">
                                <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                    <i class="fa fa-navicon"></i> Outras
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="#" @click.prevent="mtdconsultarstatus()"><i class="fa fa-flash"></i> Status da SEFAZ</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdinutilizacao()"><i class="fa fa-minus-circle"></i> Inutilização</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarlista(1)"><i class="fa fa-print"></i> Imprimir</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportarlista(0)"><i class="fa fa-file-excel-o"></i> Exportar</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdagruparpedidosnf()"><i class="fa fa-object-group"></i> Agrupar pedidos</a>
                                    <a class="dropdown-item" href="#" @click.prevent="mtdexportxml()"><i class="fa fa-download"></i> Salva xmls</a>
                                </div>
                                </div>                                
                            </div>                             
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>                           
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="parseInt(opcrud) !== 1" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbcrt">Regime tributário:</label>
                                <select name="cbmod" class="form-control form-control-sm" id="cbcrt" v-model="vcrt">
                                    <option value="1">Simples Nacional</option>
                                    <option value="2">Simples Nacional - excesso de sublimite de receita bruta</option>
                                    <option value="3">Regime Normal</option>
                                </select>
                            </div>                                   
                            <template v-if="verificapermis('020Z.020Z.060Z') || parseInt(opcrud)!==2">
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <label for="cbmodelo">Modelo:</label>
                                    <select name="cbmodelo" class="form-control form-control-sm" id="cbmodelo" v-model="vmodelo" v-bind:disabled="ativadesativa" @change.prevent="mtdverificamudancamodelo()">
                                        <option value="55">55 - NFe</option>
                                        <option value="65">65 - NFCe</option>
                                    </select>
                                </div> 
                                <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                    <label for="edserie">Série:</label>
                                    <input id="edserie" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="vserie" v-bind:disabled="parseInt(opcrud) !== 2">
                                </div> 
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednnf">Nr. Nota Fiscal:</label>
                                    <input type="text" class="form-control form-control-sm" id="ednnf" v-model="vnnf"
                                        maxlength="20" v-bind:disabled="parseInt(opcrud)!==2"/>
                                </div>
                            </template> 
                            <template v-else>
                                <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                    <label for="cbmodelo">Modelo:</label>
                                    <select name="cbmodelo" class="form-control form-control-sm" id="cbmodelo" v-model="vmodelo" disabled >
                                        <option value="55">55 - NFe</option>
                                        <option value="65">65 - NFCe</option>
                                    </select>
                                </div> 
                                <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                    <label for="edserie">Série:</label>
                                    <input id="edserie" type="text" v-mask="'###'" class="form-control form-control-sm" v-model="vserie" disabled>
                                </div> 


                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="ednnf">Nr. Nota Fiscal:</label>
                                    <input type="text" class="form-control form-control-sm" id="ednnf" v-model="vnnf"
                                        maxlength="20" disabled/>
                                </div>

                            </template> 
                          
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddthremissao">Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddthremissao" v-model="vdthremissao" :config="options"
										class="form-control form-control-sm" v-bind:disable="parseInt(opcrud) === 3"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpnf">Tipo:</label>
                                <select name="cbtpnf" class="form-control form-control-sm" id="cbtpnf" v-model="vtpnf" v-bind:disabled="ativadesativa">
                                    <option value="0">Entrada</option>
                                    <option value="1">Saída</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbtpdestinatario">Tp. Destinatário:</label>
                                <select name="cbtpdestinatario" class="form-control form-control-sm" id="cbtpdestinatario" v-model="vtpdestinatario" v-bind:disabled="ativadesativa" @change="mtddefselect2destinatario()">
                                    <option value="0">Cliente</option>
                                    <option value="1">Fornecedor</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">*Destinatário:</span>
								<select id="cbdestinatario" data-placeholder="Selecione um destinatário" v-model="viddestinatario" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbindicadorp">Indicador de presença do consumidor:</label>
                                <select name="cbindicadorp" class="form-control form-control-sm" id="cbindicadorp" v-model="vindpres" v-bind:disabled="ativadesativa">
                                    <option value="0">Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)</option>
                                    <option value="1">Operação presencial</option>
                                    <option value="2">Operação não presencial, pela Internet</option>
                                    <option value="3">Operação não presencial, Tele atendimento</option>
                                    <option value="4">NFC-e em operação com entrega a domicílio</option>
                                    <option value="5">Operação presencial, fora do estabelecimento</option>
                                    <option value="9">Operação não presencial, outros</option>
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Natureza de operação:</span>
                                <select id="cbnatop" data-placeholder="Selecione um registro" v-model="vidnatop" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbfinnfe">Finalidade da emissão:</label>
                                <select name="cbfinnfe" class="form-control form-control-sm" id="cbfinnfe" v-model="vfinnfe" v-bind:disabled="ativadesativa">
                                    <option value="1">Normal</option>
                                    <option value="2">Complementar</option>
                                    <option value="3">De ajuste</option>
                                    <option value="4">Devolução</option>
                                </select>
                            </div> 
                            <div  class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbdest">Tipo de consumidor:</label>
                                <select name="cbtpcon" class="form-control form-control-sm" id="cbtpcon" v-model="vindfinal" v-bind:disabled="ativadesativa">
                                    <option value="0">Normal</option>
                                    <option value="1">Final</option>
                                </select>
                            </div>  
                            <div  class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbdest">Destino da operação:</label>
                                <select name="cbdest" class="form-control form-control-sm" id="cbdest" v-model="viddest" v-bind:disabled="ativadesativa">
                                    <option value="1">Interna</option>
                                    <option value="2">Interestadual</option>
                                    <option value="3">Exterior</option>
                                </select>
                            </div>                               
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvnotasreferenciadas">Notas referênciadas</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvformapagamento">Forma de pagamento</a>
                                    </li>                                    									
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvcobranca">Cobrança</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvfrete">Frete</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvinformacoescomplementares">Informações complementares</a>
                                    </li>																		
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-6">
                                                    <div class="custom-control custom-switch" style="position: absolute; left: 16px;">
                                                        <input type="checkbox" class="custom-control-input" id="swcimprimereferenciaitens" name="swcimprimereferenciaitens" v-model="vimprimereferenciaitens" v-bind:disabled="ativadesativa">
                                                        <label class="custom-control-label" for="swcimprimereferenciaitens">Imprimir referência como código dos itens quando houver</label>
                                                    </div>                                                    
                                                </div>
                                                <div class="col-md-2">
                                                    <button v-show="mtdvisualizabtn('020Z.020Z.050Z')" type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdfatorarnota()"><i class="fa fa-strikethrough"></i> Fatorar</button>
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcfopparatodos()"><i class="fa fa-flag-o"></i> CFOP p/ todos</button>
                                                </div>                                                
                                            </template>
                                            <div class="col-md-12" style="margin-top: 10px;">
												<vue-bootstrap4-table
														:rows="lstitensnf"
														:columns="columnsitensnf"
														:config="config"
														:classes="classes">
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem dados para visualização</div>
													</template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes_item" slot-scope="item">
                                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_item" slot-scope="item">
                                                        {{ mtdformatarzeros(item.row.item, 3) }}
                                                    </template>
                                                    <template slot="slot_coddig" slot-scope="item">
                                                        {{ item.row.coddig }}
                                                    </template>
                                                    <template slot="slot_descproduto" slot-scope="item">
                                                        {{ item.row.descproduto }}
                                                    </template>
                                                    <template slot="slot_ncm" slot-scope="item">
                                                        {{ mtdformatarzeros(item.row.idncm, 8) }}
                                                    </template>
                                                    <template slot="slot_cst" slot-scope="item">
                                                        {{ item.row.cst }}
                                                    </template>
                                                    <template slot="slot_cfop" slot-scope="item">
                                                        {{ item.row.idcfop }}
                                                    </template>                                                                                                        
                                                    <template slot="slot_und" slot-scope="item">
                                                        {{ item.row.und }}
                                                    </template>
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.qtditem, 4) }}
                                                    </template>
                                                    <template slot="slot_vlunitario" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vlunitario, 4) }}
                                                    </template>
                                                    <template slot="slot_vltotal" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vltotal, 2) }}
                                                    </template>
                                                    <template slot="slot_vldesconto" slot-scope="item">
                                                        {{ mtdformatavalordecimal(item.row.vldesconto, 2) }}
                                                    </template>                                                                                                                                                                                        
												</vue-bootstrap4-table>                                                
                                            </div>                                                                                                                                   
										</div>
                                        <div class="row">
                                        </div>
                                    </div>
									<div id="dvnotasreferenciadas" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdnotasref()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <div v-if="lstnotasref.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistanotasref" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="100">Tipo:</th>
                                                            <th width="100">Chave de acesso:</th>
                                                            <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlocalizacaopro">
                                                            <tr v-for="(nota, index) in lstnotasref" v-bind:key="index">
                                                                <td v-if="parseInt(nota.tipo) === 0" width="100px">NF-e</td>
                                                                <td v-else width="100px">CT-e</td>
                                                                <td width="100px">{{ nota.chave }}</td>
                                                                <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletarnotaref(index)"><i class="fa fa-trash"></i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>                                                                                        
										</div>
									</div>
									<div id="dvformapagamento" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirformadepagamento()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <template v-if="lstformaspagamento.length > 0">
                                                <div class="col-lg-12">
                                                    <div class="table-responsive">
                                                        <table id="tblistaformaspagamento" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                            <thead class="thead-dark">
                                                            <tr>
                                                                <th width="30px">Id.:</th>
                                                                <th >Descrição:</th>
                                                                <th width="100px">Valor:</th>
                                                                <th width="150px">Nr. Aut:</th>
                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="lstlistaformas">
                                                                <tr v-for="(forma, index) in lstformaspagamento" v-bind:key="index">
                                                                    <td width="30px">{{ mtdformatarzeros(forma.idforma, 2) }}</td>
                                                                    <td>{{ forma.descforma }}</td>
                                                                    <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(forma.vpag, 2) }}</td>
                                                                    <td width="150px">{{ forma.caut }}</td>
                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                        v-bind:disabled="ativadesativa"
                                                                        @click.prevent="mtddeletarforma(index)"><i class="fa fa-trash"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                            <span style="color: #666666; font-weight: bold;">Soma das formas de pagamento</span>
                                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotalformas), 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </div>                                                
                                            </template>                                                     
										</div>
									</div>                                     
									<div id="dvcobranca" class="container-fluid tab-pane">
										<div class="row">
                                            <template v-if="parseInt(opcrud) < 3">
                                                <div class="col-md-10">
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirparcelacobranca()"><i class="fa fa-plus"></i> Adicionar</button>
                                                </div>
                                            </template>
                                            <template v-if="lstcobranca.length > 0">
                                                <div class="col-lg-12">
                                                    <div class="table-responsive">
                                                        <table id="tblistanotasref" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                            <thead class="thead-dark">
                                                            <tr>
                                                                <th width="100">Nr. Dup:</th>
                                                                <th width="100">Dt. Vencimento:</th>
                                                                <th width="100">Valor:</th>
                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody id="lstlistacobranca">
                                                                <tr v-for="(parcela, index) in lstcobranca" v-bind:key="index">
                                                                    <td width="100px">{{ mtdformatarzeros(parcela.ndup, 3) }}</td>
                                                                    <td width="100px">{{ parcela.dvenc }}</td>
                                                                    <td width="100px" style="text-align: right; color: #666666; font-weight: bold;">{{ mtdformatavalordecimal(parcela.vdup, 2) }}</td>
                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                        v-bind:disabled="ativadesativa"
                                                                        @click.prevent="mtddeletarparcela(index)"><i class="fa fa-trash"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <ul class="list-group">
                                                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                            <span style="color: #666666; font-weight: bold;">Soma das parcelas</span>
                                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotalcobranca), 2)}}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </template>
										</div>
									</div>
									<div id="dvfrete" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <label for="cbmodfrete">Modalidade do frete:</label>
                                                <select class="form-control form-control-sm" id="cbmodfrete" v-model="vmodfrete"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Contratação do Frete por conta do Remetente (CIF)</option>
                                                    <option value="1">Contratação do Frete por conta do Destinatário (FOB)</option>
                                                    <option value="2">Contratação do Frete por conta de Terceiros</option>
                                                    <option value="3">Transporte Próprio por conta do Remetente</option>
                                                    <option value="4">Transporte Próprio por conta do Destinatário</option>
                                                    <option value="9">Sem Ocorrência de Transporte</option>
                                                </select>
                                            </div>
                                                <div v-show="parseInt(vmodfrete) < 9" class="col-sm-12 col-md-5 col-lg-5">
                                                    <span class="lblselect2">Transportadora:</span>
                                                    <select id="cbtransportadora" data-placeholder="Selecione uma transportadora" v-model="vidtransportadora" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                    </select>
                                                </div>                                                
                                                <div v-show="parseInt(vmodfrete) < 9" class="col-md-12" style="margin-top: 15px;">
                                                    <ul class="nav nav-tabs" role="tablist">
                                                        <li class="nav-item">
                                                            <a class="nav-link active" data-toggle="tab" href="#dvtransporte">Tipo de transporte</a>
                                                        </li>                                    
                                                        <li class="nav-item">
                                                            <a class="nav-link" data-toggle="tab" href="#dvvolumes">Volumes</a>
                                                        </li>
                                                    </ul>
                                                    <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                                        <div id="dvtransporte" class="container-fluid tab-pane active">
                                                            <div class="row">
                                                                <div class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="cbtipotransporte">Tipo:</label>
                                                                    <select class="form-control form-control-sm" id="cbtipotransporte" v-model="vtipotransporte"
                                                                            v-bind:disabled="ativadesativa">
                                                                        <option value="0">Veículo</option>
                                                                        <option value="1">Reboque</option>
                                                                        <option value="2">Balsa</option>
                                                                        <option value="3">Vagão</option>
                                                                        <option value="4">Nenhum</option>
                                                                    </select>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 2" class="col-sm-12 col-md-3 col-lg-3">
                                                                    <label for="edtransp_balsa">Identificação da balsa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edtransp_balsa" v-model="vtransp_balsa"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>                                                                
                                                                <div v-show="parseInt(vtipotransporte) === 3" class="col-sm-12 col-md-3 col-lg-3">
                                                                    <label for="edtransp_vagao">Identificação do vagão:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edtransp_vagao" v-model="vtransp_vagao"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>

                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="edveic_transp_placa">Placa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_placa" v-model="vveic_transp_placa"
                                                                        maxlength="8" v-bind:disabled="ativadesativa"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-2 col-md-1 col-lg-1">
                                                                    <label for="edveic_transp_uf">UF:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_uf" v-model="vveic_transp_uf"
                                                                        maxlength="2" v-bind:disabled="ativadesativa" style="text-center"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 0" class="col-sm-12 col-md-4 col-lg-4">
                                                                    <label for="edveic_transp_rntc">RNTC:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edveic_transp_rntc" v-model="vveic_transp_rntc"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>

                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-12 col-md-2 col-lg-2">
                                                                    <label for="edreboque_transp_placa">Placa:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_placa" v-model="vreboque_transp_placa"
                                                                        maxlength="8" v-bind:disabled="ativadesativa"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-2 col-md-1 col-lg-1">
                                                                    <label for="edreboque_transp_uf">UF:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_uf" v-model="vreboque_transp_uf"
                                                                        maxlength="2" v-bind:disabled="ativadesativa" style="text-center"/>
                                                                </div>
                                                                <div v-show="parseInt(vtipotransporte) === 1" class="col-sm-12 col-md-4 col-lg-4">
                                                                    <label for="edreboque_transp_rntc">RNTC:</label>
                                                                    <input type="text" class="form-control form-control-sm" id="edreboque_transp_rntc" v-model="vreboque_transp_rntc"
                                                                        maxlength="20" v-bind:disabled="ativadesativa"/>
                                                                </div>                                                                                                                                
                                                            </div>
                                                        </div>
                                                        <div id="dvvolumes" class="container-fluid tab-pane">
                                                            <div class="row">
                                                                <template v-if="parseInt(opcrud) < 3">
                                                                    <div class="col-md-10">
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluirvolumefrete()"><i class="fa fa-plus"></i> Adicionar</button>
                                                                    </div>
                                                                </template>
                                                                <div v-if="lstvolumes.length > 0" class="col-lg-12">
                                                                    <div class="table-responsive">
                                                                        <table id="tblistavolumes" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                                            <thead class="thead-dark">
                                                                            <tr>
                                                                                <th width="20px">Item:</th>
                                                                                <th width="100">Qtd. Vol:</th>
                                                                                <th width="100">Espécie:</th>
                                                                                <th width="100">Marca:</th>
                                                                                <th width="100">Peso Líquido:</th>
                                                                                <th width="100">Peso Bruto:</th>
                                                                                <th width="100">Lacres:</th>
                                                                                <th v-show="parseInt(opcrud) < 3" width="35px" style="text-align: center;">Exc:</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody id="lstlistavolumes">
                                                                                <tr v-for="(volume, index) in lstvolumes" v-bind:key="index">
                                                                                    <td width="20px" style="text-align: center;">{{ mtdformatarzeros(volume.item, 3) }}</td>
                                                                                    <td width="100px">{{ volume.qvol }}</td>
                                                                                    <td width="100px">{{ volume.esp }}</td>
                                                                                    <td width="100px">{{ volume.marca }}</td>
                                                                                    <td width="100px">{{ volume.pesol }}</td>
                                                                                    <td width="100px">{{ volume.pesob }}</td>
                                                                                    <td width="100px">
                                                                                        <ul class="list-group">
                                                                                            <li v-for="(lacre, index) in volume.lacres" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
                                                                                                <span class="lbllacre">{{lacre.nlacre}}</span>
                                                                                            </li>
                                                                                        </ul>																			
                                                                                    </td>
                                                                                    <td v-show="parseInt(opcrud) < 3" width="35px" class="center" style="text-align: center;">
                                                                                        <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                                        v-bind:disabled="ativadesativa"
                                                                                        @click.prevent="mtddeletarvolume(index)"><i class="fa fa-trash"></i>
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>                                                                
                                                            </div>
                                                        </div>                                                                                             
                                                    </div>    
                                                </div>
										</div>
									</div>                                                                                                                   
									<div id="dvinformacoescomplementares" class="container-fluid tab-pane">
										<div class="row">
                                            <div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-8 col-lg-8">
                                                <span class="lblselect2">Informação complementar:</span>
                                                <select id="cbinfcpl" data-placeholder="Selecione uma opção" v-model="vidinfcpl"
                                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>              
                                            <div v-show="parseInt(opcrud) < 3" class="col-md-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadicionarinfcpl()" style="margin-top: 22px;"><i class="fa fa-plus"></i> Adicionar</button>
                                            </div>
                                            <div v-show="parseInt(opcrud) < 3" class="col-md-2">
                                                <button type="button" class="btn btn-danger btn-sm btn-block" @click.prevent="vinfcpl = '';" style="margin-top: 22px;"><i class="fa fa-eraser"></i> Limpar</button>
                                            </div>                                         
                                            <div class="col-sm-12" style="margin-top: 15px;">
                                                <textarea class="form-control center" rows="5" id="txtinfcpl" v-model="vinfcpl" v-bind:disabled="ativadesativa" maxlength="5000"></textarea>
                                            </div>                                            
										</div>
									</div>                                    
                                </div>
                            </div>
                            <div class="col-sm-12" style="margin-top: 15px;">
                                <div class="card" id="dvtotalizadores">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-bottom: 10px;">
                                                <div class="card">
                                                    <div class="card-body text-center" style="padding: 5px;">
                                                        <h6 id="tittotalizadores">TOTAIS DA NOTA</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total produtos <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(tprod, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total BC ICMS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tbc, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ticms, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS Des.<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ticmsdeson, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcp, 2) }}</span></a>                                                    
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total BC ICMS ST<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tbcst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total ICMS ST <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP ST <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcpst, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total FCP ST RET<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfcpstret, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total frete <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tfrete, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total seguro <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tseg, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total desconto <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tdesc, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total II<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tii, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total IPI <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tipi, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total IPI DEVOL <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tipidevol, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdettot">Total PIS <span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tpis, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total COFINS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(tcofins, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total OUTROS<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(toutro, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdettot">Total Aprox. Tributos<span class="badge badge-info bdg-totais">{{ mtdformatavalordecimal(ttottrib, 2) }}</span></a>
                                                    <a class="list-group-item lstdettot">Total da Nota<span class="badge badge-info bdg-totais" style="background-color: #5A956A;">{{ mtdformatavalordecimal(tnf, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do menu da nf -->
		<div class="modal fade" id="mdmenunf">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(nfmenu.nnf, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(nfmenu)"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(nfmenu)"><i class="fa fa-trash"></i> EXCLUIR</li>                                
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(nfmenu)" data-dismiss="modal"><i class="fa fa-clone"></i> CLONAR</li>                                
                                <li v-if="parseInt(nfmenu.situacaonota) < 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdenviar(nfmenu)"><i class="fa fa-send"></i> ENVIAR</li>                                
                                <li v-if="nfmenu.chave !== '' && nfmenu.chave !== null" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconsultarnf(nfmenu)"><i class="fa fa-refresh"></i> CONSULTAR NF</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimir(nfmenu)"><i class="fa fa-print"></i> VISUALIZAR DANFE</li>
                                <li v-if="parseInt(nfmenu.situacaonota) === 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdsalvarxmlindividual(nfmenu.id)"><i class="fa fa-download"></i> SALVAR XML/PDF</li>
                                <li v-if="parseInt(nfmenu.situacaonota) === 2 && parseInt(nfmenu.modelo) === 55" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdcartacorrecao(nfmenu.id)"><i class="fa fa-envelope-o"></i> CARTA DE CORREÇÃO</li>                                
                                <li v-if="parseInt(nfmenu.situacaonota) === 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdinfemailcliente(nfmenu)"><i class="fa fa-envelope"></i> ENVIAR P/ E-MAIL</li>                                

                                <li v-if="parseInt(nfmenu.situacaonota) >= 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinacorrecaonf(nfmenu)"><i class="fa fa-edit"></i> CORRIGIR NF</li>

								<li v-show="parseInt(nfmenu.situacaonota) === 2" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12" @click="mtdmostraropcaocancelamento()">
											<i class="fa fa-remove"></i> CANCELAR NOTA FISCAL
										</div>
										<div id="dvdefnf" class="col-md-12" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-md-12">
                                                            <label for="txtcancelanf">Motivo do cancelamento:</label>
                                                            <textarea class="form-control center" rows="5" id="txtcancelanf" v-model="vjustcancelamento" maxlength="255"></textarea>
														</div>
														<div class="col-md-12" style="margin-top: 15px;">
															<button type="button" class="btn btn-sm btn-danger btn-block" @click.prevent="mtdconfirmacaocancelamento(nfmenu)"><i class="fa fa-check"></i> Confirmar</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>                                
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>        
		<!-- Modal de edição do ítem -->
		<div class="modal fade" id="mdedicaoitem">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
						<h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração)</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidproduto">*Produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidproduto" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig)" v-on:keyup.13="mtdlocalizarproduto(vcoddig)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-8 col-lg-7">
								<label for="eddescproduto">Descrição do produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddescproduto" v-model="vdescproduto" maxlength="120" style="font-weight: bold;">
								</div>									
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edund">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edund" v-model="vund" data-bv-group=".group" maxlength="2" style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edqtditem">*Quantidade:</label>
								<money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvlunitario">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitario" v-model="vvlunitario" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvldesconto">Vl. Desconto</label>
								<money type="text" class="form-control form-control-sm" id="edvldesconto" v-model="vvldesconto" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvlfrete">Vl. Frete</label>
								<money type="text" class="form-control form-control-sm" id="edvlfrete" v-model="vvfrete" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                                                        							
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvlseguro">Vl. Seguro</label>
								<money type="text" class="form-control form-control-sm" id="edvlseguro" v-model="vvseg" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edvloutro">Vl. Outros</label>
								<money type="text" class="form-control form-control-sm" id="edvloutro" v-model="vvoutro" v-bind="money" @blur.native="mtdcalculatotalitem()" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>                                                                                                                              
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edvltotal">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotal" v-model="vvltotal" v-bind="money" readonly style="font-weight: bold; text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edxped">Ped. Compra:</label>
								<input type="text" class="form-control form-control-sm" id="edxped" v-model="vxped" data-bv-group=".group" maxlength="15" style="font-weight: bold;" title="Número do pedido de compra (Não é obrigatório)"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="ednitemped">Nr. Item:</label>
								<input type="text" class="form-control form-control-sm" id="ednitemped" v-model="vnitemped" data-bv-group=".group" maxlength="6" style="font-weight: bold;" title="Número do item no pedido de compra (Não é obrigatório)"/>
							</div>                            
                            <div class="col-md-3">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdselecionarclasse()" style="margin-top: 20px;"><i class="fa fa-folder-open"></i> Selecionar classe</button>
                            </div>
						</div>
                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">*NCM({{ vidncm }}):</span>
                                <select id="cbncm" data-placeholder="Selecione uma opção" v-model="vidncm"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">CEST({{ vidcest }}):</span>
                                <select id="cbcest" data-placeholder="Selecione uma opção" v-model="vidcest"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cborigemproduto">Origem:</label>
                                <select class="form-control form-control-sm" id="cborigemproduto"
                                    v-model="vorig" v-bind:disabled="ativadesativa">
                                    <option value="0">0 - NACIONAL, EXCETO AS INDICADAS NOS CODIGOS 3 A 5</option>
                                    <option value="1">1 - ESTRANGEIRA - IMPORTACAO DIRETA, EXCETO A INDICADA NO CODIGO 6</option>
                                    <option value="2">2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CODIGO 7</option>
                                    <option value="3">3 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO SUPERIOR A 40% (QUARENTA POR CENTO)</option>
                                    <option value="4">4 - NACIONAL, CUJA PRODUCAO TENHA SIDO FEITA EM CONFORMIDADE
                                        COM OS PROCESSOS PRODUTIVOS BASICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67 E
                                        AS LEIS N°S 8.248/91, 8.387/91,10.176/01 e 11.484/07
                                    </option>
                                    <option value="5">5 - NACIONAL, MERCADORIA OU BEM COM CONTEUDO DE IMPORTACAO
                                        INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)
                                    </option>
                                    <option value="6">6 - ESTRANGEIRA - IMPORTACAO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                    <option value="7">7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUCAO CAMEX</option>
                                </select>
                            </div>                             
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">CFOP({{ vidcfop }}):</span>
                                <select id="cbcfop" data-placeholder="Selecione uma opção" v-model="vidcfop"
                                    v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                                               
                        </div>
                        <div class="row" style="margin-top: 15px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvicms">ICMS</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvpiscofins">PIS/COFINS</a>
                                    </li>                                    
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvipi">IPI</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvicmsopinter">ICMS em operações interestaduais</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvinfadpro">Informações adicionais</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvicms" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbregime">Regime tributário:</label>
                                                <select class="form-control form-control-sm" id="cbregime" v-model="vregime" v-bind:disabled="ativadesativa" @change="mtdalteraregime()">
                                                    <option value="0">Tributação Normal</option>
                                                    <option value="1">Simples Nacional</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label v-if="parseInt(vregime) === 0" for="cbregime">Código da situação tributária:</label>
                                                <label v-else for="cbcst">CSOSN:</label>
                                                <select class="form-control form-control-sm" id="cbcst" v-model="vcst" v-bind:disabled="ativadesativa" @change="mtdselecionarcamposgrupofiscal()">
                                                    <option v-for="(item, indice) in lstcst" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>
                                            </div>
                                            <div v-show="lstcamposicms.length > 0" class="col-md-12" style="margin-top: 15px;">
                                                <div class="card">
                                                    <div v-if="parseInt(vregime) === 0" class="card-header card-in text-center" style="padding: 5px;">CAMPOS CST {{ vcst }}</div>
                                                    <div v-else class="card-header card-in text-center" style="padding: 5px;">CAMPOS CSOSN {{ vcst }}</div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <ul class="list-group">
                                                                    <li v-for="(item, indice) in lstcamposicms" v-bind:key="indice" class="list-group-item list-group-item-action lst-campos">
                                                                        <div class="row">
                                                                            <div v-if="item.listajson.length > 0" class="col-md-8">
                                                                                {{ item.descricao }}
                                                                            </div>
                                                                            <div v-else class="col-md-8">
                                                                                {{ item.descricao }}
                                                                            </div>                                                                                
                                                                            <div v-if="item.listajson.length > 0" class="col-md-4">
                                                                                <select class="form-control form-control-sm" id="cbregime" v-model="item.valor" v-bind:disabled="ativadesativa">
                                                                                    <option v-for="(opcao, indice) in item.listajson" v-bind:key="indice" v-bind:value="opcao.id">{{opcao.descricao}}</option>
                                                                                </select>                                                                                    
                                                                            </div>
                                                                            <template v-else>
                                                                                <div class="col-md-2">
                                                                                </div>
                                                                                <div class="col-md-2">
                                                                                    <money type="text" class="form-control form-control-sm" v-bind:id="'ed'+item.idcampo"
                                                                                        v-model="item.valor" v-bind="money" @blur.native="mtdcalculatotalitem()"
                                                                                        data-bv-group=".group" style="text-align:right;">
                                                                                    </money>                                                                                    
                                                                                    <!-- <money type="text" class="form-control form-control-sm"
                                                                                        v-model="item.valor" v-bind="[calculatotalitem, money]"
                                                                                        data-bv-group=".group" style="text-align:right;" v-bind:disabled="item.habilitarcadastro === 0 ? true : false">
                                                                                    </money>                                                                                          -->
                                                                                </div>
                                                                            </template>                                                                                
                                                                        </div>
                                                                    </li>  
                                                                </ul>                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                                
                                            </div>
                                        </div>                                                        
                                    </div>
                                    <div id="dvpiscofins" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <label for="cbcstpiscofins">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpiscofins" v-model="vcstpiscofins">
                                                    <option v-for="(item, indice) in cstpiscofins" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppis">Alíquota PIS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppis"
                                                        v-model="vppis" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpis">Valor do PIS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpis"
                                                        v-model="vvpis" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                                         
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edppisst">Alíquota PIS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edppisst"
                                                        v-model="vppisst" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpisst">Valor do PIS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpisst"
                                                        v-model="vvpisst" v-bind="money"
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofins">Alíquota COFINS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofins"
                                                        v-model="vpcofins" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvcofins">Valor do COFINS:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvcofins"
                                                        v-model="vvcofins" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                               
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpcofinsst">Alíquota COFINS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpcofinsst"
                                                        v-model="vpcofinsst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvcofinsst">Valor do COFINS ST:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvcofinsst"
                                                        v-model="vvcofinsst" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div id="dvipi" class="container-fluid tab-pane">
                                        <div class="row">                                            
                                            <div class="col-md-12">
                                                <label for="cbcstipi">Código da situação tributária:</label>
                                                <select class="form-control form-control-sm" id="cbcstpipi" v-model="vcstipi" v-bind:disabled="ativadesativa">
                                                    <option v-for="(item, indice) in cstipi" v-bind:key="indice" v-bind:value="item.codigo">{{item.codigo}} - {{item.descricao}}</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edpipi">Alíquota IPI:</label>
                                                <money type="text" class="form-control form-control-sm" id="edpipi"
                                                        v-model="vpipi" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvipi">Valor do IPI:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvipi"
                                                        v-model="vvipi" v-bind="money" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                            
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edcenq">Código de enquadramento:</label>
                                                <input type="text" class="form-control form-control-sm" id="edcenq"
                                                    v-model="vcenq" v-bind:disabled="ativadesativa"
                                                    data-bv-group=".group" maxlength="3">
                                            </div>                                                                                         
                                        </div>
                                    </div>
                                    <div id="dvicmsopinter" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edvpfcpufdedt">Percentual ICMS relativo ao FCP na UF do destino:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpfcpufdedt"
                                                        v-model="vpfcpufdedt" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvbcufdest">Valor da base de cálculo na UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvbcufdest"
                                                        v-model="vbcufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edvpicmsufdest">Aliq. interna da UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvpicmsufdest"
                                                        v-model="vpicmsufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpicmsinter">Aliq. interestadual:</label>
                                                <select class="form-control form-control-sm" id="cbvpicmsinter" v-model="vpicmsinter" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">4% aliquota interestadual para produtos importados</option>
                                                    <option value="2">7% para estados do sul e sudeste (exceto ES), destinados para estados do norte e nordeste ou ES</option>
                                                    <option value="3">12% para os demais casos</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-md-12">
                                                <label for="cbvpimsinterpart">Percentual provisório de partilha:</label>
                                                <select class="form-control form-control-sm" id="cbvpimsinterpart" v-model="vpimsinterpart" v-bind:disabled="ativadesativa">
                                                    <option value="0"></option>
                                                    <option value="1">40% em 2016</option>
                                                    <option value="2">60% em 2017</option>
                                                    <option value="3">80% em 2018</option>
                                                    <option value="4">100% a partir de 2019</option>
                                                </select>                                                
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufdest">Valor do ICMS de partilha para UF do destinatário:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufdest"
                                                        v-model="vicmsufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div> 
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvicmsufremet">Valor do ICMS de partilha para UF do remetente:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvicmsufremet"
                                                        v-model="vicmsufremet" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>  
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edvfcpufdest">Valor do ICMS relativo ao FCP da UF de destino:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvfcpufdest"
                                                        v-model="vfcpufdest" v-bind="money" v-bind:disabled="ativadesativa" 
                                                        data-bv-group=".group" style="text-align:right;">
                                                </money>
                                            </div>                                                                          
                                        </div>
                                    </div>  
                                    <div id="dvinfadpro" class="container-fluid tab-pane">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprod" maxlength="500"></textarea>
                                            </div>
                                            <div class="col-md-12 text-right">
                                                <span class="text-black-50" style="font-size: 12px; font-weight: 600;">{{ vinfadprod.length }} caracteres de 500</span>
                                            </div>                                            
                                        </div>
                                    </div>                                                                                                                                     
                                </div>    
                            </div>
                        </div>                        
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para seleção da classe -->
		<div class="modal fade" id="mdselecionarclasse">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group">								
                                <a v-for="(classe, index) in lstclasses" href="#" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="mtddefineclasse(classe)">{{ mtdformatarzeros(classe.id, 2) }} - {{ classe.descricao }}</a>
							</div>							
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
        <!-- Modal para seleção do fator de divisão -->
		<div class="modal fade" id="mdselecionafator">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
                            <div class="col-12">
								<label for="edfator">*Fator(%):</label>
								<money type="text" class="form-control form-control-sm" id="edfator" v-model="vfator" v-bind="money" data-bv-group=".group"  style="text-align:right;"></money>
							</div>		
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12">
                                <div class="row justify-content-end">
                                    <button type="button" class="btn btn-primary btn-sm"  @click.prevent="mtdgravafator()" > Confirmar</button>
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="margin-left: 20px" ><i class="fa fa-close"></i> Cancelar</button>
                                </div>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
		<!-- Modal de inclusão de nfe/cte referênciadas -->
		<div class="modal fade" id="mdnotaref">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de NF-e/CT-e referenciada</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbtiponfref">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtiponfref" v-model="vtiponfref">
                                    <option value="0">NF-e</option>
                                    <option value="1">CT-e</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edchavenfref">*Chave de acesso:</label>
                                <input type="text" v-model="vchavenfref"
                                        class="form-control form-control-sm" id="edchavenfref" maxlength="60">
                            </div>                                                 						
						</div>                                               
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarnotaref()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de cobrança -->
		<div class="modal fade" id="mdcobranca">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de parcela da cobrança</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-6 col-lg-6">
								<label for="eddvenc">*Dt. Vencimento:</label>
								<div class="input-group">
									<date-picker id="eddvenc" v-model="vdvenc" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-sm-12 col-md-6 col-lg-6">
								<label for="edvdup">*Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvdup" v-model="vvdup" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
							</div>
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarparcela()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de formas de pagamento -->
		<div class="modal fade" id="mdformapagamento">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de forma de pagamento</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div  class="col-sm-12 col-md-8 col-lg-8">
                                <span class="lblselect2">*Forma de pagamento:</span>
                                <select id="cbformapagamento" data-placeholder="Selecione uma forma" v-model="vidforma" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvpag">*Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvpag" v-model="vvpag" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
							</div>
                            <div v-if="visualizacaut" class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edcaut">Nr. Autorização:</label>
                                <input type="text" v-model="vcaut"
                                        class="form-control form-control-sm" id="edcaut" maxlength="20">
                            </div>                                                                                     
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarformapagamento()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de volumes de frete -->
		<div class="modal fade" id="mdvolumefrete">
			<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-edit"></i> Inclusão de volume</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edqvol">Qtd. Volumes:</label>
                                <money type="text" class="form-control form-control-sm" id="edqvol" v-bind="money"
                                        v-model="vqvol" v-bind:disabled="ativadesativa"></money>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edesp">Espécie:</label>
                                <input type="text" v-model="vesp" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edesp" maxlength="60">
                            </div>                                                       						
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edmarca">Marca:</label>
                                <input type="text" v-model="vmarca" v-bind:disabled="ativadesativa"
                                        class="form-control form-control-sm" id="edmarca" maxlength="60">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="ednvol">Num. volumes:</label>
                                <input type="text" v-model="vnvol" v-bind:disabled="ativadesativa" title="Numeração dos volumes"
                                        class="form-control form-control-sm" id="ednvol" maxlength="60">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpesol">Peso líquido:</label>
                                <money type="text" class="form-control form-control-sm" id="edpesol" v-bind="peso"
                                        v-model="vpesol" v-bind:disabled="ativadesativa"></money>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edpesob">Peso bruto:</label>
                                <money type="text" class="form-control form-control-sm" id="edpesob" v-bind="peso"
                                        v-model="vpesob" v-bind:disabled="ativadesativa"></money>
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">LACRES</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="ednlacre">Nr. Lacre:</label>
                                                <input type="text" class="form-control form-control-sm" id="ednlacre"
                                                        v-model="vnlacre" data-bv-group=".group" maxlength="60">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" id="btinclacre" class="btn btn-info btn-sm"
                                                        @click.prevent="mtdincluirlacre()"
                                                        style="width:100%; margin-top: 22px; margin-bottom: 10px;">
                                                    <i class="fa fa-plus-circle"></i> Incluir</button>
                                            </div>
                                            <div v-if="lstlacres.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistalacres" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th>Nr. Lacre:</th>
                                                            <th width="35px" style="text-align: center;">Exc:</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstlacresvolume">
                                                            <tr v-for="(lacre, index) in lstlacres" v-bind:key="index">
                                                                <td>{{ lacre.nlacre }}</td>
                                                                <td width="35px" class="center" style="text-align: center;">
                                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    v-bind:disabled="ativadesativa"
                                                                    @click.prevent="mtddeletarlacre(index)"><i class="fa fa-trash"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                                        
                            </div>
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravarvolumefrete()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de cartas de correção -->
		<div class="modal fade" id="mdcartacorrecao">
			<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-envelope-o"></i> Cartas de correção</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div id="dvlistacartas" class="row">
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>NF. Número:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.nnf" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>Série:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.serie" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-4 col-lg-4 col-xl-2">
                                <label>Modelo:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.modelo" disabled style="font-weight: bold; text-align: right;">
                            </div>                            
                            <div class="col-md-12 col-lg-12 col-xl-6">
                                <label>Chave de acesso:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.chave" disabled style="font-weight: bold; text-align: center;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <label>Filial:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.fantasiafil" disabled style="font-weight: bold;">
                            </div>                             
                            <div class="col-md-6 col-lg-6 col-xl-4">
                                <label>Destinatário:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.nomedestinatario" disabled style="font-weight: bold;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-2">
                                <label>Emissão:</label>
                                <input type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.dthremissao" disabled style="font-weight: bold; text-align: right;">
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-2">
                                <label>Total da Nota:</label>
                                <money type="text" class="form-control form-control-sm" v-model="nfcartacorrecao.totalnota" v-bind="money" style="font-weight: bold; text-align:right;" disabled></money>
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">CARTAS DE CORREÇÕES EXISTENTES PARA A NF-e</div>
                                    <div class="card-body" style="padding-top: 15px; padding-bottom: 5px;">
                                        <div class="row">
                                            <div class="col-md-8 col-lg-10 col-xl-10">
                                            </div>
                                            <div class="col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdincluircarta()">
                                                    <i class="fa fa-plus-circle"></i> Incluir
                                                </button>
                                            </div>
                                            <div v-if="lstcartas.length > 0" class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table id="tblistacartas" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                        <thead class="thead-dark">
                                                        <tr>
                                                            <th width="80px" style="text-align: center;">Nr. Carta:</th>
                                                            <th width="100px" style="text-align: center;">Situação:</th>                                                            
                                                            <th>Texto da carta de correção:</th>                                                            
                                                            <th>Retorno sefaz:</th>
                                                            <th width="130px" style="text-align: center;">Opções:</th>                                                            
                                                        </tr>
                                                        </thead>
                                                        <tbody id="lstcartas">
                                                            <tr v-for="(carta, index) in lstcartas" v-bind:key="index">
                                                                <td style="text-align: center;">{{ mtdformatarzeros(carta.nseqevento, 2) }}</td>
                                                                <td v-if="parseInt(carta.situacaocc) === 0" style="text-align: center;">
                                                                    <span class="badge badge-primary bdg-digitacao">Em digitação</span>
                                                                </td>
                                                                <td v-else style="text-align: center;">
                                                                    <span class="badge badge-primary bdg-autorizada">Enviada</span>
                                                                </td>                                                                    
                                                                <td>{{ carta.xcorrecao }}</td>
                                                                <td>{{ carta.xmotivo }}</td>
                                                                <td width="35px" class="center" style="text-align: center;">
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-info btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdenviarcarta(carta)" title="Enviar"><i class="fa fa-paper-plane"></i></a>                                                                         
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdalterarcarta(carta)" title="Alterar"><i class="fa fa-edit"></i></a> 
                                                                    <a v-if="parseInt(carta.situacaocc) === 0" class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtddeletarcarta(carta)" title="Excluir"><i class="fa fa-trash"></i></a>
                                                                    <a v-if="parseInt(carta.situacaocc) === 1" class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
                                                                    @click.prevent="mtdimprimircarta(carta)" title="Imprimir"><i class="fa fa-print"></i></a>                                                                        
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                                        
                            </div>                            
						</div>
                        <div id="dvedicaocarta" class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">{{ titcartacorrecao }}</div>
                                    <div class="card-body" style="padding-top: 5px; padding-bottom: 5px;">
                                        <div class="row">
                                            <div class="col-sm-10 col-md-8 col-lg-8 col-xl-10">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2">
                                                <label>Dt. Emissão:</label>
                                                <div class="input-group">
                                                    <date-picker v-model="vdthremissaocarta" :config="options"
                                                        class="form-control form-control-sm" disabled></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>										
                                                </div>
                                            </div>                                            
                                            <div class="col-md-12">
                                                <label>Texto da carta de correção:</label>
                                                <textarea class="form-control center" rows="5" id="txtconteudocarta" v-model="vconteudocarta" maxlength="1000"></textarea>
                                            </div>
                                            <div class="col-md-12">
                                                <label>Condições de uso da carta de correção:</label>
                                                <p id="pcondusucarta">
                                                    A Carta de Correção é disciplinada pelo parágrafo 1º - A do art. 7o do Convênio S/N, de 15 de dezembro de 1970 e pode ser utilizada para regularização de erro ocorrido na 
                                                    emissão de documento fiscal, desde que o erro nao esteja relacionado com: I - as variáveis que determinam o valor do imposto tais como: base de cálculo, alíquota, diferença 
                                                    de preço, quantidade, valor da operação ou da prestacão; II - a correção de dados cadastrais que implique mudanca do remetente ou do destinatário; III - a data de emissão 
                                                    ou de saída.                                                    
                                                </p>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="row" style="padding-bottom: 10px;">
                                            <div class="col-12 col-sm-4 col-md-4 col-lg-8 col-xl-8">
                                            </div>
                                            <div class="col-6 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdgravarcartacorrecao()">
                                                    <i class="fa fa-check"></i> Gravar
                                                </button>                                                
                                            </div>
                                            <div class="col-6 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicaocartacorrecao()">
                                                    <i class="fa fa-close"></i> Cancelar
                                                </button>                                                                                                
                                            </div>                                                                                        
                                        </div>
                                    </div>                                    
                                </div>                                                        
                            </div>
                        </div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 130px;"><i class="fa fa-sign-out"></i> Sair</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal de inutilização -->
		<div class="modal fade" id="mdinutilizacao">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-minus-circle"></i> Inutilização</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialinutilizacao" data-placeholder="Selecione uma filial" v-model="iidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                                <label>Modelo:</label>
                                <select name="cbmodeloinutilizacao" class="form-control form-control-sm" id="cbmodeloinutilizacao" v-model="inmodelo">
                                    <option value="55">55 - NF-e</option>
                                    <option value="65">65 - NFC-e</option>
                                </select>
                            </div>
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                                <label>Série:</label>
                                <input id="edserieinutilizacao" type="number" v-mask="'###'" class="form-control form-control-sm" v-model="inserie">
                            </div>
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                <label>Nr. Inicial:</label>
                                <input id="ednini" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="inini">
                            </div>
                            <div class="col-6 col-sm-6 col-md-6 col-lg-6">
                                <label>Nr. Final:</label>
                                <input id="ednfim" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="infim">
                            </div>
                            <div class="col-sm-12">
                                <label>Motivo da inutilização:</label>
                                <textarea class="form-control center" rows="5" id="txtmotivoinutilizacao" v-model="ixjust" maxlength="255"></textarea>
                            </div>                                                                                                
						</div>                       
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarinutilizacao()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Atribuir cfop para todos os itens --> 
        <div class="modal fade" id="mdatribuircfop" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir Classe de imposto à produtos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">                
                            <div class="col-md-12">
                                <span class="lblselect2">CFOP:</span>
                                <select id="cbcfoptodos" data-placeholder="Selecione uma opção"
                                    v-model="vidcfoptodos"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircfop()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div> 
        <!-- Informa o e-amil do cliente para enviar xml e danfe --> 
        <div class="modal fade" id="mdinfemailcliente" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-envelope" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Enviar Xml e Danfe por e-mail</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">  
                            <div class="col-12">
                                <label for="edinfemailcliente">Informe o e-mail do cliente:</label>
                                <input type="edinfemailcliente" v-model="emailenviar"
                                    class="form-control form-control-sm" id="edinfemailcliente" maxlength="100"
                                    style="text-transform: lowercase;">
                            </div>                                          
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdenviardocsnfcliente()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>
        <!-- Rotina para correção da chave e xml da nfe --> 
        <div class="modal fade" id="mdcorrecaonf" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-qrcode" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Correção NF: {{mtdformatarzeros(cnfcorrecao.nnf, 8)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row">  
                            <div class="col-12">
                                <label for="edcchavenf">Informe a chave NF:</label>
                                <input type="text" v-model="cchavenf"
                                    class="form-control form-control-sm" id="edcchavenf" maxlength="150">
                            </div>
                            <div class="col-12" style="margin-top: 15px;">
                                <label for="txclayoutxml">Layout XML:</label>
                                <textarea class="form-control center" rows="5" id="txclayoutxml" v-model="clayoutxml"></textarea>
                            </div> 
                            <div class="col-12" style="margin-top: 15px;">
                                <div class="alert alert-danger">
                                    <strong>*Caso não tenha conhecimento desta rotina, não realize, entre em contato com nosso suporte técnico.</strong><br>
                                    <strong>*Após fazer a correção da NF, favor realizar uma consulta da mesma para atualização do seu status.</strong>
                                </div>                                
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmacorrecaonf()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div> 
        <!-- Rotina para agrupamento dos pedidos --> 
        <div class="modal fade" id="mdagruparpedidos" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-object-group" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Agrupamento de pedidos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialagr" data-placeholder="Selecione uma filial" v-model="aidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                      
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclienteagr" data-placeholder="Selecione um cliente" v-model="aidcliente" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtiniagr">De:</label>
								<div class="input-group">
									<date-picker id="eddtiniagr" v-model="adtini" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfimagr">até:</label>
								<div class="input-group">
									<date-picker id="eddtfimagr" v-model="adtfim" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>														
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistaragr" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdpesquisarpedidosagr()" style="margin-top: 20px;"><i class="fa fa-search"></i> Listar</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th @click.prevent="mtdmarcartodos()"><i class="fa fa-plus-square-o" style="cursor: pointer; font-size: 16px; position: absolute; top: 20px; left: 25px;"></i></th>
                                            <th>Nr. Pedido:</th>
                                            <th></th>
                                            <th>Cliente:</th>
                                            <th>Dt. fatura:</th>
                                            <th>Total:</th>
                                            <th>Plano:</th>
                                            <th>Rota:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(pedido, index) in lstpedidosagrupar" v-bind:key="index" style="font-size: 12px;">
                                                <td style="cursor: pointer; width: 30px; font-weight: bold; text-align: center; font-size: 18px;" @click.prevent="mtdhabilita(index)">
                                                    <i v-if="parseInt(pedido.selecionado) === 1" class="fa fa-check-square"></i>
                                                    <i v-else class="fa fa-square-o"></i>
                                                </td>
                                                <td style="width: 90px; font-weight: bold;">{{mtdformatarzeros(pedido.id, 8)}}</td>
                                                <td style="width: 30px; text-align: center;"><i @click.prevent="mtddetalhespedido(pedido.id)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
                                                <td>{{pedido.nomecliente}}</td>
                                                <td style="width: 140px;">{{pedido.dtfatura}}</td>
                                                <td style="width: 120px; text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
                                                <td style="width: 180px;">{{pedido.descplano}}</td>
                                                <td style="width: 180px;">{{pedido.descrota}}</td>
                                            </tr>
                                        </tbody>                                        
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-show="lstpedidosagrupar.length > 0" class="row">
                            <div class="col-12 col-sm-8 col-md-10 col-lg-10">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilialnf" data-placeholder="Selecione uma filial" v-model="aidfilialnf" data-allow-clear="true" style="width:100%;" v-bind:disabled="!alterafilialnf">
							    </select>
						    </div> 
                            <div class="col-12 col-sm-4 col-md-2 col-lg-2">
                                <label for="cbmodeloagr">Modelo:</label>
                                <select name="cbmodeloagr" class="form-control form-control-sm" id="cbmodelo" v-model="amodelo">
                                    <option value="55">55 - NFe</option>
                                    <option value="65">65 - NFCe</option>
                                </select>
                            </div>                                                       
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdconfirmaagrupamento()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>  
            <!-- Modal para configurar exportação xml --> 
        <div class="modal fade" id="mdexportxml" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-file-archive-o" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Exportar xml por período</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialexport" data-placeholder="Selecione uma filial" v-model="vidfilialexport" data-allow-clear="true" style="width:100%;">
								</select>
							</div> 
                        </div>
                        <div style="padding-top: 20px;" class="row">  
                            <div class="col-3">
                                <div class="custom-control custom-switch" style="padding-top: 20px;">
                                    <input type="checkbox" class="custom-control-input" id="swcespecificarperiodo" name="swcespecificarperiodo" v-model="vespecificarperiodo">
                                    <label class="custom-control-label" for="swcespecificarperiodo">Especificar?</label>
                                </div> 
                            </div>                            
                            <template v-if="!vespecificarperiodo">
                                    <div class="col-6">
                                        <label for="cbmes">Período:</label>
                                        <select name="cbmes" class="form-control form-control-sm" id="cbmes" v-model="messelect" >
                                            <option value="0">Janeiro</option>
                                            <option value="1">Fevereiro</option>
                                            <option value="2">Março</option>
                                            <option value="3">Abril</option>
                                            <option value="4">Maio</option>
                                            <option value="5">Junho</option>
                                            <option value="6">Julho</option>
                                            <option value="7">Agosto</option>
                                            <option value="8">Setembro</option>
                                            <option value="9">Outubro</option>
                                            <option value="10">Novembro</option>
                                            <option value="11">Dezembro</option>
                                        </select>
                                    </div> 

                                    <div class="col-3">
                                        <label for="cbano">Ano:</label>
                                        <select name="cbano" class="form-control form-control-sm" id="cbano" v-model="anoselect" >
                                            <option v-for="(ano, index) in anoslista" :key="index" :value="ano">{{ ano }}</option>
                                        </select>
                                    </div> 
                            </template>
                            <template v-else>
                                    <div class="col-1">
                                    </div>
                                    <div class="col-4">
                                        <label for="eddtini">De:</label>
                                        <div class="input-group">
                                            <date-picker id="eddtini" v-model="pdtinixml" :config="options" class="form-control form-control-sm" ></date-picker>
                                            <div class="input-group-append">
                                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                            </div>								
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <label for="eddtfim">até:</label>
                                        <div class="input-group">
                                            <date-picker id="eddtfim" v-model="pdtfimxml" :config="options" class="form-control form-control-sm" ></date-picker>
                                            <div class="input-group-append">
                                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                            </div>																			
                                        </div>
                                    </div>                            
                            </template>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdsalvarxmls()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'
    import DetalhesPedido from '../components/cmpdetalhespedido.vue'

    export default {
        name: 'cadnotasfiscais',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos,
            'detalhespedido'  	: DetalhesPedido,
        },
        data: function() {
            return {
                nfmenu              : [],
                
                //variável para visualização do detalhe do pedido
                vidpedidodet : '',

                tipopropesquisa     : '',

                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                lstnotasfiscais     : [],
                lstinutilizacoes    : [],
                lstitensnf          : [],
                lstnotasref         : [],
                lstcobranca         : [],
                lstformaspagamento  : [],
                lstvolumes          : [],
                pmodelo             : 99,
                pserie              : '',
                pnnf                : '',
                pidfilial           : null,
                pidnatop            : null,
                ptpdestinatario     : 0,
                piddestinatario     : null,
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),	                
                pqtdregistros       : 10,
                pqtd_paginas        : 1,
                pagina_atual        : 1,
                pqtd_total_registros: 0,
                ptotalnotas         : 0,


                //variaveis nova exportação xml
                anoslista           : [],
                anoAtual            : 0,
                anoselect           : 0,
                vespecificarperiodo : false,
                messelect           : 0,  
                vidfilialexport     : null,

                pdtinixml       	: util.DataAtual(true),
				pdtfimxml           : util.DataAtual(true),	 

                //filtro inutilizadas
                pfiltroinutilizadas : '',

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vidfilial           : null,
                vcrt                : '1',
                viduffilial         : '',
                vmodelo             : '',
                vserie              : '',
                vnnf                : '',
                vtpnf               : '1',
                vtpdestinatario     : '0',
                vindpres            : '1',
                vindfinal           : '0',
                viddest             : '1',
                vidnatop            : null,
                vdthremissao        : util.DataAtual(true),
                vfinnfe             : '1',
                viddestinatario     : null,
                vidinfcpl           : null,
                vinfcpl             : '',
                vimprimereferenciaitens : false,
                vmodfrete           : 9,
                vidtransportadora   : null,
                vtipotransporte     : 4,
                vveic_transp_placa  : '',
                vveic_transp_uf     : '',
                vveic_transp_rntc   : '',
                vreboque_transp_placa : '',
                vreboque_transp_uf    : '',
                vreboque_transp_rntc  : '',
                vtransp_vagao       : '',
                vtransp_balsa       : '',

                //variáveis para comparação na alteração da nf
                vidfilial_old       : null,
                vmodelo_old         : '',

                vtotalcobranca      : 0,
                vtotalformas        : 0,

                //totalizadores
                tbc 			    : 0,
                ticms 		        : 0,
                ticmsdeson 	        : 0,
                tfcp 			    : 0,
                tbcst 		        : 0,
                tst 			    : 0,
                tfcpst 		        : 0,
                tfcpstret 	        : 0,
                tprod 		        : 0,
                tfrete 		        : 0,
                tseg 			    : 0,
                tdesc 		        : 0,
                tii 			    : 0,
                tipi 			    : 0,
                tipidevol 	        : 0,
                tpis 			    : 0,
                tcofins 		    : 0,
                toutro 		        : 0,
                tnf 			    : 0,
                ttottrib 		    : 0,                

                //variáveis da consulta de produtos
                vidtabela           : null,
                vshowprtabela       : false,

                //variável para habilitação dos campos
                ativadesativa       : true,

                lstcst              : [],

                cstnormal   : [
                    {codigo : '00', descricao : 'Tributada integralmente'},
                    {codigo : '10', descricao : 'Tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '20', descricao : 'Com redução de base de cálculo'},
                    {codigo : '30', descricao : 'Isenta ou não tributada e com cobrança do ICMS por substituição tributária'},
                    {codigo : '40', descricao : 'Isenta'},
                    {codigo : '41', descricao : 'Não tributada'},
                    {codigo : '50', descricao : 'Suspensão'},
                    {codigo : '51', descricao : 'Diferimento'},
                    {codigo : '60', descricao : 'ICMS cobrado anteriormente por substituição tributária'},
                    {codigo : '70', descricao : 'Com redução de base de cálculo e cobrança do ICMS por substituição tributária'},
                    {codigo : '90', descricao : 'Outros'}
                ],
                cstsimples  : [
                    {codigo : '101', descricao : 'Tributada pelo Simples Nacional com permissão de crédito'},
                    {codigo : '102', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito'},
                    {codigo : '103', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta'},
                    {codigo : '201', descricao : 'Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '202', descricao : 'Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária'},
                    {codigo : '203', descricao : 'Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária'},
                    {codigo : '300', descricao : 'Imune'},
                    {codigo : '400', descricao : 'Não tributada pelo Simples Nacional'},
                    {codigo : '500', descricao : 'ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação'},
                    {codigo : '900', descricao : 'Outros'}
                ],
                cstpiscofins : [
                    {codigo : '01', descricao : 'Operação Tributável com Alíquota Básica'},
                    {codigo : '02', descricao : 'Operação Tributável com Alíquota Diferenciada'},
                    {codigo : '03', descricao : 'Operação Tributável com Alíquota por Unidade de Medida de Produto'},
                    {codigo : '04', descricao : 'Operação Tributável Monofásica - Revenda a Alíquota Zero'},
                    {codigo : '05', descricao : 'Operação Tributável por Substituição Tributária'},
                    {codigo : '06', descricao : 'Operação Tributável a Alíquota Zero'},
                    {codigo : '07', descricao : 'Operação Isenta da Contribuição'},
                    {codigo : '08', descricao : 'Operação sem Incidência da Contribuição'},
                    {codigo : '09', descricao : 'Operação com Suspensão da Contribuição'},
                    {codigo : '49', descricao : 'Outras Operações de Saída'},
                    {codigo : '50', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '51', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '52', descricao : 'Operação com Direito a Crédito - Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '53', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '54', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '55', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Não Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '56', descricao : 'Operação com Direito a Crédito - Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '60', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Tributada no Mercado Interno'},
                    {codigo : '61', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita Não-Tributada no Mercado Interno'},
                    {codigo : '62', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada Exclusivamente a Receita de Exportação'},
                    {codigo : '63', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno'},
                    {codigo : '64', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '65', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '66', descricao : 'Crédito Presumido - Operação de Aquisição Vinculada a Receitas Tributadas e Não-Tributadas no Mercado Interno e de Exportação'},
                    {codigo : '67', descricao : 'Crédito Presumido - Outras Operações'},
                    {codigo : '70', descricao : 'Operação de Aquisição sem Direito a Crédito'},
                    {codigo : '71', descricao : 'Operação de Aquisição com Isenção'},
                    {codigo : '72', descricao : 'Operação de Aquisição com Suspensão'},
                    {codigo : '73', descricao : 'Operação de Aquisição a Alíquota Zero'},
                    {codigo : '74', descricao : 'Operação de Aquisição sem Incidência da Contribuição'},
                    {codigo : '75', descricao : 'Operação de Aquisição por Substituição Tributária'},
                    {codigo : '98', descricao : 'Outras Operações de Entrada'},
                    {codigo : '99', descricao : 'Outras Operações'}
                ],
                cstipi       : [
                    {codigo : '00', descricao : 'Entrada com Recuperação de Crédito'},
                    {codigo : '01', descricao : 'Entrada Tributada com Alíquota Zero'},
                    {codigo : '02', descricao : 'Entrada Isenta'},
                    {codigo : '03', descricao : 'Entrada Não Tributada'},
                    {codigo : '04', descricao : 'Entrada Imune'},
                    {codigo : '05', descricao : 'Entrada com Suspensão'},
                    {codigo : '49', descricao : 'Outras Entradas'},
                    {codigo : '50', descricao : 'Saída Tributada'},
                    {codigo : '51', descricao : 'Saída Tributável com Alíquota Zero'},
                    {codigo : '52', descricao : 'Saída Isenta'},
                    {codigo : '53', descricao : 'Saída Não Tributada'},
                    {codigo : '54', descricao : 'Saída Imune'},
                    {codigo : '55', descricao : 'Saída com Suspensão'},
                    {codigo : '99', descricao : 'Outras Saídas'}
                ],


                //variáveis de edição do item
                vopitem             : 0,
                vitem               : 0,
                vitemalt            : 0,//item para alteração
                vcoddig             : '',
                vidproduto          : '',
                vdescproduto        : '',
                vund                : '',
                vqtditem            : 1,
                vvlunitario         : 0,
                vvldesconto         : 0,
                vvltotal            : 0,
                vvfrete             : 0,
                vvseg               : 0,
                vvoutro             : 0,
                vidncm              : null,
                vidcest             : null,
                vidcfop             : null,
                vorig               : '0',
                valiquotaibpt       : 0,
                vregime             : 0,
                vcst                : '', 
                vcstpiscofins       : '01',
                vcstipi             : '99',                              
                vppis               : 0,
                vvpis               : 0,
                vppisst             : 0,
                vvpisst             : 0,
                vpcofins            : 0,
                vvcofins            : 0,
                vpcofinsst          : 0,
                vvcofinsst          : 0,
                vpipi               : 0,
                vvipi               : 0,
                vcenq               : '999',
                vinfadprod          : '',
                vxped               : '',
                vnitemped           : '',
                lstcamposicms       : [],  
                
                // PARTILHA DE ICMS
                vbcufdest           : 0,
                vpfcpufdedt         : 0,
                vpicmsufdest        : 0,
                vpicmsinter         : 0,
                vpimsinterpart      : 0,
                vfcpufdest          : 0,
                vicmsufdest         : 0,
                vicmsufremet        : 0,
                ////////////////////////

                //notas referenciadas
                vtiponfref          : 0,
                vchavenfref         : '',

                //cobrança
                vdvenc              : util.DataAtual(true),
                vvdup               : 0,

                //forma de pagamento
                formaselecionada    : [],
                visualizacaut       : false,
                vidforma            : null,
                vvpag               : 0,
                vcaut               : '',

                //frete
                vqvol               : 0,
                vesp                : '',
                vmarca              : '',
                vnvol               : '',
                vpesol              : 0,
                vpesob              : 0,
                lstlacres           : [],
                vnlacre             : '',  
                
                //variável com o motivo para o cancelamento nf
                vjustcancelamento   : '',


                //variaveis da carta de correção
                opcarta             : 0,
                titcartacorrecao    : '',
                nfcartacorrecao     : [],
                lstcartas           : [],

                vnseqevento         : '',
                vdthremissaocarta   : util.DataAtual(true),
                vconteudocarta      : '',


                //variáveis para inutilização
                iidfilial           : null,
                idthremissao        : util.DataAtual(true),
                inmodelo            : '55',
                inserie             : '',
                inini               : '',
                infim               : '',
                ixjust              : '',

                //lista das classes para seleção do usuário
                lstclasses          : [],

                //atribuir cfop para todos os itens
                vidcfoptodos        : null,

                //variáveis para envio do e-email
                idnfemailenviar     : 0,
                emailenviar         : '',
                
                //variáveis para correção da NF
                cnfcorrecao         : [],
                cchavenf            : '',
                clayoutxml          : '',

                //variáveis para fatorar nota
                vfator              : 0,

                //variáveis para agrupamento dos pedidos
				alterafilialnf		: false,//carrega do perfil do usuário                
                aidfilial           : null,
                aidcliente          : null,
				adtini       		: util.DataAtual(true),
				adtfim       		: util.DataAtual(true),
                lstpedidosagrupar   : [], 
                aidfilialnf         : null,
                amodelo             : 55,               

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
				peso				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',
                    precision       : 3,
                    masked          : false
                },                
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'NOTAS FISCAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-nf",
                        sort: false
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Nr. Nota",
                        name: "nnf",
                        sort: true,
                        slot_name: "slot_nnf",
                        row_classes: "def-col-nnf",
                    },
                    {
                        label: "Situação",
                        name: "situacaonota",
                        sort: true,
                        slot_name: "slot_situacaonota",
                        row_classes: "def-col-situacaonota",
                    },                    
                    {
                        label: "Modelo",
                        name: "modelo",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-modelo"
                    },
                    {
                        label: "Série",
                        name: "serie",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_serie",
                        row_classes: "def-col-serie"
                    },
                    {
                        label: "Emissão",
                        name: "dthremissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_dthremissao",
                        row_classes: "def-col-dthremissao"
                    },                    
                    {
                        label: "Destinatário",
                        name: "nomedestinatario",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Natureza operação",
                        name: "descnatop",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "totalnota",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_valor",
                        row_classes: "def-col-valor"
                    },
                    {
                        label: "Retorno sefaz",
                        name: "xmotivo",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_xmotivo",
                        row_classes: "def-col-xmotivo"
                    },
                    {
                        label: "Chave",
                        name: "chave",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_chave",
                        row_classes: "def-col-chave"
                    }
                ],
                columnsitensnf: [
                    {
                        label: 'Opções',
                        name : 'opcoes_item',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_item",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_coddig",
                    },
                    {
                        label: "Descrição do item",
                        name: "descproduto",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_descproduto",
                    },
                    {
                        label: "NCM",
                        name: "idncm",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_ncm",
                    },
                    {
                        label: "CST/CSOSN",
                        name: "cst",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst",
                    },
                    {
                        label: "CFOP",
                        name: "idcfop",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cfop",
                    },
                    {
                        label: "P/C",
                        name: "cstpiscofins",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst_piscofins",
                    },
                    {
                        label: "IPI",
                        name: "cstipi",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_cst_ipi",
                    },                    
                    {
                        label: "Und",
                        name: "und",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_und",
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_qtditem",
                    },
                    {
                        label: "Vl. Unitário",
                        name: "vlunitario",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vlunitario",
                    },
                    {
                        label: "Vl. Total",
                        name: "vltotal",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vltotal",
                    },
                    {
                        label: "Vl. Desconto",
                        name: "vldesconto",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        slot_name: "slot_vldesconto",
                    }                                                                                                                                  
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            verificapermis(op){
               return util.opcaousuario(op, this.$store.state.perfilusuario);
            },
            mtdexportxml(){
                this.vespecificarperiodo = false;
                this.vidfilialexport     = null;
                $('#cbfilialexport').val(null).trigger('change');
                $('#mdexportxml').modal('show');
            },
            mtdfatorarnota(){
                $('#mdselecionafator').modal('show');
            },
            mtdvisualizabtn(op){                
                return util.opcaousuario(op, this.$store.state.perfilusuario);
            },
            mtdgravafator(){
                let vself = this
                if(vself.vfator===0){
                    vself.$toastr.w('Informe o fator correto!', 'Informação!'); 
                }else if(vself.lstitensnf.length === 0){
                    vself.$toastr.w('Não há itens na nota para esta operação!', 'Informação!'); 
                }else if(vself.vfator > 100){
                    vself.$toastr.w('Informe o fator correto!', 'Informação!'); 
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma a fatoração dos itens?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    vself.mtdregistrofator();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#edfator').focus();
                                }
                            }
                        }
                    });
                }
            },
            mtdregistrofator(){
                console.log('inicio')
                    let vself = this; 
                    let loader      = this.$loading.show();    
                for (let index = 0; index < this.lstitensnf.length; index++) {
                    vself.vopitem             = 2;
                    vself.vitemalt            = vself.lstitensnf[index].item;
                    vself.vcoddig             = vself.lstitensnf[index].coddig;
                    vself.vidproduto          = vself.lstitensnf[index].idproduto;
                    vself.vdescproduto        = vself.lstitensnf[index].descproduto;
                    vself.vund                = vself.lstitensnf[index].und;
                    vself.vqtditem            = vself.lstitensnf[index].qtditem;
                    vself.vvlunitario         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vlunitario * (this.vfator / 100)), 3, 'round');  // aplicar aqui
                    vself.vvldesconto         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vldesconto * (this.vfator / 100)), 3, 'round');  // aplicar aqui
                    vself.vvltotal            = util.arredondaValores(parseFloat(vself.lstitensnf[index].vltotal  * (this.vfator / 100)), 2, 'round');
                    vself.vvfrete             = vself.lstitensnf[index].vfrete;  
                    vself.vvseg               = util.arredondaValores(parseFloat(vself.lstitensnf[index].vseg * (this.vfator / 100)), 3, 'round');    //aplicar aqui
                    vself.vvoutro             = util.arredondaValores(parseFloat(vself.lstitensnf[index].voutro * (this.vfator / 100)), 3, 'round'); // aplicar aqui
                    vself.vidncm              = vself.lstitensnf[index].idncm;
                    vself.vidcest             = vself.lstitensnf[index].idcest;
                    vself.vidcfop             = vself.lstitensnf[index].idcfop;
                    vself.vorig               = vself.lstitensnf[index].orig;                  
                    vself.vregime             = vself.lstitensnf[index].regime;
                    //// partilha de icms 
                    vself.vbcufdest           = util.arredondaValores(parseFloat(vself.lstitensnf[index].vbcufdest * (this.vfator / 100)), 3, 'round');
                    vself.vpfcpufdedt         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vpfcpufdedt * (this.vfator / 100)), 3, 'round');
                    vself.vpicmsufdest        = vself.lstitensnf[index].vpicmsufdest;
                    vself.vpicmsinter         = vself.lstitensnf[index].vpicmsinter;
                    vself.vpimsinterpart      = vself.lstitensnf[index].vpimsinterpart;
                    vself.vfcpufdest          = util.arredondaValores(parseFloat(vself.lstitensnf[index].vfcpufdest * (this.vfator / 100)), 3, 'round');
                    vself.vicmsufdest         = util.arredondaValores(parseFloat(vself.lstitensnf[index].vicmsufdest * (this.vfator / 100)), 3, 'round');
                    vself.vicmsufremet        = util.arredondaValores(parseFloat(vself.lstitensnf[index].vicmsufremet * (this.vfator / 100)), 3, 'round');
                    ///////////////////////////////////////////////

                    if (parseInt(vself.vregime) === 0){
                        vself.lstcst = vself.cstnormal;
                    }else{
                        vself.lstcst = vself.cstsimples;
                    }                

                    vself.vcst                = vself.lstitensnf[index].cst; 
                    vself.vcstold             = vself.lstitensnf[index].cst;
                    vself.vcstpiscofins       = vself.lstitensnf[index].cstpiscofins;
                    vself.vcstipi             = vself.lstitensnf[index].cstipi;                              
                    vself.vppis               = vself.lstitensnf[index].ppis;
                    vself.vvpis               = vself.lstitensnf[index].vpis;
                    vself.vppisst             = vself.lstitensnf[index].ppisst;
                    vself.vvpisst             = vself.lstitensnf[index].vpisst;
                    vself.vpcofins            = vself.lstitensnf[index].pcofins;
                    vself.vvcofins            = vself.lstitensnf[index].vcofins;
                    vself.vpcofinsst          = vself.lstitensnf[index].pcofinsst;
                    vself.vvcofinsst          = vself.lstitensnf[index].vcofinsst;
                    vself.vpipi               = vself.lstitensnf[index].pipi;
                    vself.vvipi               = vself.lstitensnf[index].vipi;
                    vself.vcenq               = vself.lstitensnf[index].cenq;
                    vself.vinfadprod          = vself.lstitensnf[index].infadprod;
                    vself.vxped               = vself.lstitensnf[index].xped;
                    vself.vnitemped           = vself.lstitensnf[index].nitemped;      

                    vself.lstcamposicms       = JSON.parse(JSON.stringify( vself.lstitensnf[index].campos));
                    vself.lstcamposicmsold    = JSON.parse(JSON.stringify( vself.lstitensnf[index].campos));

                    vself.mtdcalculatotalitem();



                    vself.lstitensnf[index].item                = vself.vitemalt;
                    vself.lstitensnf[index].coddig              = vself.vcoddig;
                    vself.lstitensnf[index].idproduto           = vself.vidproduto;
                    vself.lstitensnf[index].descproduto         = vself.vdescproduto;
                    vself.lstitensnf[index].item                = vself.vitemalt;
                    vself.lstitensnf[index].coddig              = vself.vcoddig;
                    vself.lstitensnf[index].und                 = vself.vund;
                    vself.lstitensnf[index].qtditem             = vself.vqtditem;
                    vself.lstitensnf[index].vlunitario          = vself.vvlunitario;
                    vself.lstitensnf[index].vldesconto          = vself.vvldesconto;
                    vself.lstitensnf[index].vltotal             = vself.vvltotal;
                    vself.lstitensnf[index].vfrete              = vself.vvfrete;
                    vself.lstitensnf[index].vseg                = vself.vvseg;
                    vself.lstitensnf[index].voutro              = vself.vvoutro;
                    vself.lstitensnf[index].idncm               = vself.vidncm;
                    vself.lstitensnf[index].idcest              = vself.vidcest;
                    vself.lstitensnf[index].idcfop              = vself.vidcfop;
                    vself.lstitensnf[index].orig                = vself.vorig;
                    vself.lstitensnf[index].regime              = vself.vregime;
                    vself.lstitensnf[index].vbcufdest           = vself.vbcufdest;
                    vself.lstitensnf[index].vpfcpufdedt         = vself.vpfcpufdedt;
                    vself.lstitensnf[index].vpicmsufdest        = vself.vpicmsufdest;
                    vself.lstitensnf[index].vpicmsinter         = vself.vpicmsinter;
                    vself.lstitensnf[index].vpimsinterpart      = vself.vpimsinterpart;
                    vself.lstitensnf[index].vfcpufdest          = vself.vfcpufdest;
                    vself.lstitensnf[index].vicmsufdest         = vself.vicmsufdest;
                    vself.lstitensnf[index].vicmsufremet        = vself.vicmsufremet;
                    vself.lstcst                                = parseInt(vself.vregime) === 0 ? vself.cstnormal : vself.cstsimples;
                    vself.lstitensnf[index].cst                 = vself.vcst;
                    vself.lstitensnf[index].cstold              = vself.vcstold;
                    vself.lstitensnf[index].cstpiscofins        = vself.vcstpiscofins;
                    vself.lstitensnf[index].cstipi              = vself.vcstipi;
                    vself.lstitensnf[index].ppis                = vself.vppis;
                    vself.lstitensnf[index].vpis                = vself.vvpis;
                    vself.lstitensnf[index].ppisst              = vself.vppisst;
                    vself.lstitensnf[index].vpisst              = vself.vvpisst;
                    vself.lstitensnf[index].pcofins             = vself.vpcofins;
                    vself.lstitensnf[index].vcofins             = vself.vvcofins;
                    vself.lstitensnf[index].pcofinsst           = vself.vpcofinsst;
                    vself.lstitensnf[index].vcofinsst           = vself.vvcofinsst;
                    vself.lstitensnf[index].pipi                = vself.vpipi;
                    vself.lstitensnf[index].vipi                = vself.vvipi;
                    vself.lstitensnf[index].cenq                = vself.vcenq;
                    vself.lstitensnf[index].infadprod           = vself.vinfadprod;
                    vself.lstitensnf[index].xped                = vself.vxped;
                    vself.lstitensnf[index].nitemped            = vself.vnitemped;   

                    vself.lstitensnf[index].campos              = vself.lstcamposicms; 
                    //vself.lstcamposicmsold    = vself.lstitensnf[index].campos
 
                    vself.mtdlimparedicaoitem();
                    vself.mtdtotalizarnota();
                }
                vself.vfator = 0;
               
                loader.hide();  
                $('#mdselecionafator').modal('hide');
            },
            mtdexportarlista(excel){
                let vself   = this;              
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadnotasfiscais.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&filtroinutilizadas='+vself.pfiltroinutilizadas+
                            '&dtini='+dtini+
                            '&excel='+excel+
                            '&dtfim='+dtfim+
                            '&filial='+filial+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            },   
            mtdmostrarmenu(nf){				
                this.nfmenu = nf;
                $('#dvdefnf').hide();
				$('#mdmenunf').modal('show');
            },
            mtdmostraropcaocancelamento(){
                this.vjustcancelamento = '';
                $('#dvdefnf').toggle(300);
                let visivel  = $('#dvdefnf').is(':visible');
                if (visivel){
                   $('#txtcancelanf').focus(); 
                }
            },
            mtdconsultarproduto(){
				if (parseInt(this.vopitem) === 1){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
            },             
            mtdvisualizainut(){
               let ret = false;
               let situacoes = $('#sbsituacao').selectpicker('val');
               for (let i = 0; i < situacoes.length; i++) {
                   if (parseInt(situacoes[i]) === 5){
                       ret = true;
                       break;
                   }
               }
               return ret; 
            },        
            mtdfiltropesquisa(){
                let rfiltro = ''; 

                //filtro das inutilizações
                this.pfiltroinutilizadas = '';

                if (parseInt(this.pmodelo) < 99){
                    rfiltro = ' and nf.modelo='+this.pmodelo;
                    this.pfiltroinutilizadas = ' and i.nmodelo='+this.pmodelo;
                }
                if (this.pidfilial !== null){
                    rfiltro = rfiltro + ' and nf.idfilial='+this.pidfilial;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.idfilial='+this.pidfilial;
				}
                if (this.pidnatop !== null){
                    rfiltro = rfiltro + ' and nf.idnatop='+this.pidnatop;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.idnatop='+this.pidnatop;
				}                
                if ($('#sbsituacao').selectpicker('val').length > 0){
                    rfiltro = rfiltro + ' and nf.situacaonota in ('+$('#sbsituacao').selectpicker('val')+')';
                }                
                // if (this.pdestinatario !== ''){
                //     rfiltro = rfiltro + ' and upper(nf.nomedestinatario) like upper("'+this.pdestinatario+'%")';
                // }
                if (this.piddestinatario !== null){
                    rfiltro = rfiltro + ' and nf.iddestinatario='+this.piddestinatario;
				}
                if (this.pserie !== ''){
                    rfiltro = rfiltro + ' and nf.serie='+this.pserie;
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.nserie='+this.pserie;
                }
                if (this.pnnf !== ''){
                    rfiltro = rfiltro + ' and nf.nnf='+this.pnnf;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
                    rfiltro = rfiltro + ' and nf.dthremissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                    this.pfiltroinutilizadas = this.pfiltroinutilizadas + ' and i.dthremissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
                }				                                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor  : 'qtdregistros'},
                    {parametro: 'filtro',               valor  : filtro}                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarreganotasfiscais(1, '');
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarreganotasfiscais(ipagina, filtrocrud){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [];
                if (!vself.mtdvisualizainut()){
                    parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtrocrud !== '' ? filtrocrud : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    ];
                }else{
                    parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtrocrud !== '' ? filtrocrud : filtro},
                        {parametro: 'filtroinutilizadas',   valor  : this.pfiltroinutilizadas},
                        {parametro: 'limit',        valor : vself.pqtdregistros},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                    ];                        
                }
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    vself.ptotalnotas     = response.data.totalnotas;  
                    vself.lstnotasfiscais = response.data.notas;
                    vself.lstinutilizacoes= response.data.inutilizacoes;
                    loader.hide();
                }).catch(function (response) {
                    vself.ptotalnotas       = 0;
                    vself.lstnotasfiscais   = [];
                    vself.lstinutilizacoes  = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.lstitensnf         = [];
                this.lstnotasref        = [];
                this.lstcobranca        = [];
                this.lstformaspagamento = [];
                this.lstvolumes         = [];                
                this.vid                = '';
                this.vnnf               = '';
                this.vtpnf              = '1';
                this.vmodelo            = '55';
                this.vserie             = '';
                this.vtpdestinatario    = '0';
                this.vindpres           = '1';
                this.vindfinal          = '0';
                this.vidfilial          = null;
                this.vcrt               = 1;
                this.vidnatop           = null;
                this.viduffilial        = '';
                this.vdthremissao       = util.DataAtual(true);
                this.vfinnfe            = '1';
                this.viddestinatario    = null;
                this.vidinfcpl          = null;
                this.vinfcpl            = '';
                this.vimprimereferenciaitens= false;
                this.vmodfrete              = 9;
                this.vidtransportadora      = null;
                this.vtipotransporte        = 4;
                this.vveic_transp_placa     = '';
                this.vveic_transp_uf        = '';
                this.vveic_transp_rntc      = '';
                this.vreboque_transp_placa  = '';
                this.vreboque_transp_uf     = '';
                this.vreboque_transp_rntc   = '';
                this.vtransp_vagao          = '';
                this.vtransp_balsa          = '';                

                this.vtotalcobranca     = 0;
                this.vtotalformas       = 0;

                //totalizadores
                this.tbc 			    = 0;
                this.ticms 		        = 0;
                this.ticmsdeson 	    = 0;
                this.tfcp 			    = 0;
                this.tbcst 		        = 0;
                this.tst 			    = 0;
                this.tfcpst 		    = 0;
                this.tfcpstret 	        = 0;
                this.tprod 		        = 0;
                this.tfrete 		    = 0;
                this.tseg 			    = 0;
                this.tdesc 		        = 0;
                this.tii 			    = 0;
                this.tipi 			    = 0;
                this.tipidevol 	        = 0;
                this.tpis 			    = 0;
                this.tcofins 		    = 0;
                this.toutro 		    = 0;
                this.tnf 			    = 0;
                this.ttottrib 		    = 0;                

                $('#cbinfcpl').val(null).trigger('change');
                $('#cbfilial').val(null).trigger('change');
                $('#cbdestinatario').val(null).trigger('change');
                $('#cbnatop').val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbfilial').select2('open');
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 300);
            },
            mtddadosfilial(idfilial){
                let vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.codfil='+vself.vidfilial;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.viduffilial = response.data[0].iduf;
                    if (parseInt(vself.opcrud) === 1){
                        vself.vcrt        = response.data[0].crt;
                    }
                    if (vself.vnatope === ''){
                        vself.vnatope = response.data[0].natope;
                    }
                    if (vself.vserie === ''){
                        vself.vserie  = response.data[0].serie55;
                    }
                    if (parseInt(vself.opcrud) === 2){
                        if (parseInt(idfilial) !== vself.vidfilial_old){
                            vself.mtdcarregaultnf();
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdcarregaultnf(){                
                let vself       = this;
                vself.$toastr.i('A troca de filial ocasiona a alteração do Número da NF. Verifique corretamente a numeração!', 'Informação!');                
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'pegaultnnf'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',     valor : vself.vidfilial},
                    {parametro: 'modelo',       valor : vself.vmodelo},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.vnnf  = response.data;
                }).catch(function (response) {
                    vself.vnnf  = '';
                    loader.hide();
                });
            },
            mtddefselect2destinatario(){
                let vself             = this;
                vself.viddestinatario = null;                				
				$("#cbdestinatario").val(null).trigger('change');
				$("#cbdestinatario").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q       : params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb      : parseInt(vself.vtpdestinatario) === 0 ? 'tbclientes' : 'tbfornecedores',
								c1	    : 'id',
								c2	    : parseInt(vself.vtpdestinatario) === 0 ? 'nome' : 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.viddestinatario = $("#cbdestinatario").val();
				});
            },
            mtddefselect2destinatariopesq(){
                let vself             = this;
                vself.piddestinatario = null;                				
				$("#cbdestinatariopesq").val(null).trigger('change');
				$("#cbdestinatariopesq").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q       : params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb      : parseInt(vself.ptpdestinatario) === 0 ? 'tbclientes' : 'tbfornecedores',
								c1	    : 'id',
								c2	    : parseInt(vself.ptpdestinatario) === 0 ? 'nome' : 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.piddestinatario = $("#cbdestinatariopesq").val();
				});
            },            
            mtdselect2_def(){
                let vself = this;                
                //sql para pegar somente as filiais do usuário
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';
                
                $('#sbsituacao').selectpicker({
                    noneResultsText : 'Sem resultados',
                    noneSelectedText: 'Nenhuma selecionada',
                    selectAllText   : 'Todas',
                    deselectAllText : 'Nenhuma'

                });
                $('#sbsituacao').selectpicker('selectAll');

				$('#mdcartacorrecao').on('show.bs.modal', function (e) {
                    $('#dvedicaocarta').hide();
                    $('#dvlistacartas').show();                                        
                });	
				$('#mdedicaoitem').on('show.bs.modal', function (e) {
                    if (parseInt(vself.vopitem) === 1){
                        vself.mtdlimparedicaoitem();
                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                    }
                });                			
				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidproduto').focus();
					}else{
						$('#edqtditem').focus();
					}
                });
				$('#mdnotaref').on('shown.bs.modal', function (e) {
					$('#cbtiponfref').focus();
                });                
				$('#mdcobranca').on('shown.bs.modal', function (e) {
					$('#eddvenc').focus();
                });                                
				$('#mdformapagamento').on('shown.bs.modal', function (e) {
					$('#cbformapagamento').focus();
                });                 
				$('#mdvolumefrete').on('shown.bs.modal', function (e) {
					$('#edqvol').focus();
                }); 
				$('#mdmenunf').on('show.bs.modal', function (e) {
                });
				$('#mdatribuircfop').on('shown.bs.modal', function (e) {                    
					$('#cfoptodos').select2('open');
                });

				$('#mdinutilizacao').on('shown.bs.modal', function (e) {
					$('#cbfilialinutilizacao').focus();
                }); 
                
				$('#mdinfemailcliente').on('shown.bs.modal', function (e) {
					$('#edinfemailcliente').focus();
                }); 

				$('#mdcorrecaonf').on('shown.bs.modal', function (e) {                    
					$('#edcchavenf').focus();
                });

				$('#mdagruparpedidos').on('shown.bs.modal', function (e) {  
                    vself.lstpedidosagrupar = [];                  
					var deffilial  			= new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
					$('#cbfilialagr').append(deffilial).trigger('change');	                    

                    $('#cbclienteagr').val(null).trigger('change');

					$('#cbfilialagr').select2('open');
                });    

                $('#mdselecionafator').on('shown.bs.modal', function (e) {
					vself.vfator = 0;
                });
                
                $("#cbfilialexport").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilialexport = $("#cbfilialexport").val();  
                });

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilial = $("#cbfilial").val();
                    vself.mtddadosfilial(vself.vidfilial);                   
                });
                $("#cbnatop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidnatop = $("#cbnatop").val();
                });                                                                                  
                $("#cbncm").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbncms',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 3,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidncm = $("#cbncm").val();
                    if (vself.vidncm !== null){
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',               valor : 'aliquotaibpt'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'idncm',            valor : vself.vidncm},
                            {parametro: 'uf',               valor : vself.viduffilial}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadncms.php');
                        retorno.then(function (response) {
                            vself.valiquotaibpt         = response.data;
                            loader.hide();						
                        }).catch(function (response) {
                            vself.valiquotaibpt = 0;
                            loader.hide();
                        });                        
                        
                    }
                });
                $("#cbcest").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcests',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcest = $("#cbcest").val();
                });                 
                $("#cbcfop").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfop = $("#cbcfop").val();
                });                                

                $("#cbinfcpl").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbinformacoescomplementares',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidinfcpl = $("#cbinfcpl").val();
                });

                $("#cbformapagamento").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbformaspagamento',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidforma = $("#cbformapagamento").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.id='+vself.vidforma;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.formaselecionada  = response.data[0];
                        if (response.data.length > 0){
                            vself.visualizacaut     = parseInt(vself.formaselecionada.tef) === 0 ? false : true;
                        }else{
                            vself.visualizacaut     = false;
                        }
                        vself.vcaut             = '';                        
                    }).catch(function (response) {
                        loader.hide();
                    });                    
                });

				$("#cbtransportadora").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtransportadoras',
                                c1: 'id',
                                c2: 'fantasia'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtransportadora = $("#cbtransportadora").val();
                });

                vself.mtddefselect2destinatario();                   
                vself.mtddefselect2destinatariopesq();                   

                //selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
                });
                $("#cbnatoppesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbnaturezasoperacoesnf',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidnatop = $("#cbnatoppesq").val();
                    vself.mtdlimpar_listagem();
                });                                    
                //inutilização
				$("#cbfilialinutilizacao").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.iidfilial = $("#cbfilialinutilizacao").val();
                });
                
                $("#cbcfoptodos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcfops',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidcfoptodos = $("#cbcfoptodos").val();
                }); 
                
                //agrupamento de pedidos
				$("#cbfilialagr").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.aidfilial         = $("#cbfilialagr").val();
                    vself.lstpedidosagrupar = [];

					var deffilial  			= new Option($('#cbfilialagr').select2('data')[0]['text'], vself.aidfilial, true, true);
					$('#cbfilialnf').append(deffilial).trigger('change');	                    

				});                
				$("#cbclienteagr").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.aidcliente        = $("#cbclienteagr").val();
                    vself.lstpedidosagrupar = [];
				}); 
				$("#cbfilialnf").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.aidfilialnf = $("#cbfilialnf").val();
				});                               
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                $('.nav-tabs a[href="#dvtransporte"]').tab('show'); 
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('020Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE NOTA FISCAL';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstnotasfiscais = [];
                this.lstinutilizacoes= [];
                this.ptotalnotas     = 0;
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) === 2){//rotina para alteração quando o usuário pode alterar o número da nota e/ou série
                    if (vself.vserie === ''){
                        vself.$toastr.w('Número de série deve ser informado!', 'Atenção!');    
                        $('#edserie').focus();
                        return;
                    }
                    if (vself.vnnf === ''){
                        vself.$toastr.w('Número da nota deve ser informado!', 'Atenção!');    
                        $('#ednnf').focus();
                        return;
                    }                    
                }
                if (parseInt(vself.opcrud) < 3){
                    for (let i = 0; i < vself.lstitensnf.length; i++) {
                        if (vself.lstitensnf[i].cstpiscofins === '' || vself.lstitensnf[i].cstpiscofins === null){
                            vself.$toastr.w('CST PIS/COFINS do item: '+vself.lstitensnf[i].item+' não informado. Verifique e tente novamente!', 'Atenção!');                            
                            return;
                        }
                        if (vself.lstitensnf[i].cstipi === '' || vself.lstitensnf[i].cstipi === null){
                            vself.$toastr.w('CST IPI do item: '+vself.lstitensnf[i].item+' não informado. Verifique e tente novamente!', 'Atenção!');                            
                            return;
                        }                        
                    } 
                    if (parseFloat(vself.vtotalformas).toFixed(2) !== parseFloat(vself.tnf).toFixed(2)){
                        if (util.arredondaValores(parseFloat(vself.vtotalformas), 2, 'round') !== util.arredondaValores(parseFloat(vself.tnf), 2, 'round')){
                            vself.$toastr.w('Total das formas de pagamento não confere com o total da nota. Verifique e tente novamente!', 'Atenção!');
                            $('.nav-tabs a[href="#dvformapagamento"]').tab('show');
                            return;
                        }                        
                    }                   
                    // if (vself.lstcobranca.length > 0){
                    //     if (parseFloat(vself.vtotalcobranca) !== parseFloat(vself.tnf) ){
                    //         vself.$toastr.w('Total da cobrança não confere com o total da nota. Verifique e tente novamente!', 'Atenção!');
                    //         $('.nav-tabs a[href="#dvcobranca"]').tab('show');
                    //         return;
                    //     }
                    // }
                    if (parseInt(vself.vmodfrete) > 1 && parseInt(vself.vmodfrete) < 9){//Verificações quanto as informações do frete
                        if (vself.vidtransportadora === null){
                            vself.$toastr.w('Transportadora deve ser informada!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('#cbtransportadora').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 0 && (vself.vveic_transp_placa === '' || vself.vveic_transp_uf === '' || vself.vveic_transp_rntc === '')){
                            vself.$toastr.w('As informações do veículo de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#cbtipotransporte').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 1 && (vself.vreboque_transp_placa === '' || vself.vreboque_transp_uf === '' || vself.vreboque_transp_rntc === '')){
                            vself.$toastr.w('As informações do reboque de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#cbtipotransporte').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 2 && vself.vtransp_balsa === ''){
                            vself.$toastr.w('As informações da balsa de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#edtransp_balsa').focus();
                            return;
                        }
                        if (parseInt(vself.vtipotransporte) === 3 && vself.vtransp_vagao === ''){
                            vself.$toastr.w('As informações da balsa de transporte devem ser informadas!', 'Atenção!');    
                            $('.nav-tabs a[href="#dvfrete"]').tab('show');
                            $('.nav-tabs a[href="#dvtransporte"]').tab('show');                                        
                            $('#edtransp_vagao').focus();
                            return;
                        }
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id, clone){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and nf.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (!clone){
                        if (parseInt(response.data.notas[0].situacaonota) > 1){
                            vself.$toastr.i('Para ALTERAR ou EXCLUIR a nota, a situação da mesma deve estar em digitação ou somente enviada!', 'Informação!');
                            vself.mtdcancelaredicao();
                            return;
                        }
                    }
                    vself.mtdigualarcampos(response.data.notas[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE NOTA FISCAL';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id, false);
                }
            },
            mtdclonar(item){
                let vself = this;
                if (!util.opcaousuario('020Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE NOTA FISCAL';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.mtdlocalizaregistro(item.id, true);
                    setTimeout(() => {                            
                        vself.vid                = '';
                        vself.vnnf               = '';
                        vself.vserie             = '';
                        vself.vidfilial          = null;                            
                        vself.lstnotasref    = [];
                        vself.lstcobranca    = [];
                        var deffilial  = new Option(item.fantasiafil, item.idfilial, true, true);
                        $('#cbfilial').append(deffilial).trigger('change');
                    }, 500); 
                }                
            },
            mtdexcluir(item){
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE NOTA FISCAL';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id, false);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vnnf                   = registro.nnf;
                this.vtpnf                  = registro.tpnf;
                this.vmodelo                = registro.modelo;
                this.vserie                 = registro.serie;
                this.vtpdestinatario        = registro.tpdestinatario;
                this.vindpres               = registro.indpres;
                this.vindfinal              = registro.indfinal;
                this.viddest                = parseInt(registro.iddest);
                this.vidfilial              = registro.idfilial;                
                this.vidnatop               = registro.idnatop;
                this.vdthremissao           = parseInt(registro.modelo) === 55 ? registro.dthremissao : util.DataAtual(true);
                this.vfinnfe                = registro.finnfe;
                this.viddestinatario        = registro.iddestinatario;
                this.vinfcpl                = registro.infcpl;
                this.vimprimereferenciaitens= parseInt(registro.imprimereferenciaitens) === 0 ? false : true;
                this.vmodfrete              = registro.modfrete;
                this.vidtransportadora      = registro.idtransportadora;
                this.vtipotransporte        = registro.tipotransporte;
                this.vveic_transp_placa     = registro.veic_transp_placa;
                this.vveic_transp_uf        = registro.veic_transp_uf;
                this.vveic_transp_rntc      = registro.veic_transp_rntc;
                this.vreboque_transp_placa  = registro.reboque_transp_placa;
                this.vreboque_transp_uf     = registro.reboque_transp_uf;
                this.vreboque_transp_rntc   = registro.reboque_transp_rntc;
                this.vtransp_vagao          = registro.transp_vagao;
                this.vtransp_balsa          = registro.transp_balsa;                		

                //númeo da nf a verificar durante a alteração
                this.vidfilial_old          = registro.idfilial;
                this.vmodelo_old            = registro.modelo;             

                //totalizadores
                this.tbc 			        = registro.vbc;
                this.ticms 		            = registro.vicms;
                this.ticmsdeson 	        = registro.vicmsdeson;
                this.tfcp 			        = registro.vfcp;
                this.tbcst 		            = registro.vbcst;
                this.tst 			        = registro.vst;
                this.tfcpst 		        = registro.vfcpst;
                this.tfcpstret 	            = registro.vfcpstret;
                this.tprod 		            = registro.vprod;
                this.tfrete 		        = registro.vfrete;
                this.tseg 			        = registro.vseg;
                this.tdesc 		            = registro.vdesc;
                this.tii 			        = registro.vii;
                this.tipi 			        = registro.vipi;
                this.tipidevol 	            = registro.vipidevol;
                this.tpis 			        = registro.vpis;
                this.tcofins 		        = registro.vcofins;
                this.toutro 		        = registro.voutro;
                this.tnf 			        = registro.vnf;
                this.ttottrib 		        = registro.vtottrib;
    
                this.lstitensnf             = registro.itens;
                this.lstnotasref            = registro.notasref;
                //this.lstcobranca            = registro.parcelas;
                this.lstformaspagamento     = registro.formas;
                this.lstvolumes             = registro.volumes;


                this.lstcobranca = [];
                if (registro.parcelas.length > 0){
                    for (let i = 0; i < registro.parcelas.length; i++) {
                        let parcelatmp = {
                            ndup  : registro.parcelas[i].ndup,
                            dordem: new Date(util.formatardataDB(registro.parcelas[i].dvenc)),
                            dvenc : registro.parcelas[i].dvenc,
                            vdup  : parseFloat(registro.parcelas[i].vdup)
                        };
                        this.lstcobranca.push(parcelatmp);                                              
                    }
                }

                var deffilial  = new Option(registro.fantasiafil, this.vidfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');

                this.vcrt                   = registro.crt;

                var defnatop  = new Option(registro.descnatop, this.vidnatop, true, true);
                $('#cbnatop').append(defnatop).trigger('change');

                var defdestinatario  = new Option(registro.nomedestinatario, this.viddestinatario, true, true);
                $('#cbdestinatario').append(defdestinatario).trigger('change');
                if (this.vidtransportadora !== null && parseInt(this.vidtransportadora) !== 0){
                    var deftransp  = new Option(registro.fantasiatransp, this.vidtransportadora, true, true);
                    $('#cbtransportadora').append(deftransp).trigger('change');                
                }else{
                    $('#cbtransportadora').val(null).trigger('change'); 
                }
                
                this.mtdtotalizaformaspagamento();
                this.mtdordenarparcelas();
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                    : this.vid,
                    'idfilial' 				: this.vidfilial,
                    'crt'                   : this.vcrt,
                    'modelo' 				: this.vmodelo,
                    'serie' 				: this.vserie,
                    'nnf' 					: this.vnnf,
                    'tpnf' 					: this.vtpnf,
                    'indpres' 	         	: this.vindpres,
                    'indfinal' 	         	: this.vindfinal,
                    'iddest' 	         	: this.viddest,
                    'tpdestinatario' 		: this.vtpdestinatario,
                    'finnfe' 				: this.vfinnfe,
                    'iddestinatario' 		: this.viddestinatario,
                    'idnatop' 				: this.vidnatop,
                    'nomedestinatario' 		: $('#cbdestinatario').select2('data')[0]['text'],
                    'cpfcnpjconsumidor' 	: '',
                    'dthremissao'           : this.vdthremissao, 
                    'totalnota' 			: this.tnf,
                    'vtroco' 				: 0,
                    'vbc' 					: this.tbc,
                    'vicms' 				: this.ticms,
                    'vicmsdeson' 			: this.ticmsdeson,
                    'vfcp' 					: this.tfcp,
                    'vbcst' 				: this.tbcst,
                    'vst' 					: this.tst,
                    'vfcpst' 				: this.tfcpst,
                    'vfcpstret' 			: this.tfcpstret,
                    'vprod' 				: this.tprod,
                    'vfrete' 				: this.tfrete,
                    'vseg' 					: this.tseg,
                    'vdesc' 				: this.tdesc,
                    'vii' 					: this.tii,
                    'vipi' 					: this.tipi,
                    'vipidevol' 			: this.tipidevol,
                    'vpis' 					: this.tpis,
                    'vcofins' 				: this.tcofins,
                    'voutro' 				: this.toutro,
                    'vnf' 					: this.tnf,
                    'vtottrib' 				: this.ttottrib,
                    'modfrete' 				: this.vmodfrete,
                    'idtransportadora' 		: this.vidtransportadora,
                    'tipotransporte' 		: this.vtipotransporte,
                    'veic_transp_placa' 	: this.vveic_transp_placa,
                    'veic_transp_uf' 		: this.vveic_transp_uf,
                    'veic_transp_rntc' 		: this.vveic_transp_rntc,
                    'reboque_transp_placa' 	: this.vreboque_transp_placa,
                    'reboque_transp_uf' 	: this.vreboque_transp_uf,
                    'reboque_transp_rntc' 	: this.vreboque_transp_rntc,
                    'transp_vagao' 			: this.vtransp_vagao,
                    'transp_balsa' 			: this.vtransp_balsa,
                    'infadfisco' 			: '',
                    'infcpl' 				: this.vinfcpl,
                    'imprimereferenciaitens': this.vimprimereferenciaitens === false ? 0 : 1,
                    'itens'                 : this.lstitensnf,
                    'notasref'              : this.lstnotasref,
                    'formas'                : this.lstformaspagamento,
                    'parcelas'              : this.lstcobranca,
                    'volumes'               : this.lstvolumes
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.009X.001Z' : parseInt(this.opcrud) === 2 ? '001Z.009X.002Z' : '001Z.009X.003Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                        vself.pconteudo             = '';//parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas          = 1;
                        //vself.pnnf                  = response.data;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, ' and nf.id='+response.data);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },			
			mtdlimparedicaoitem(){
                this.vcoddig             = '';
                this.vidproduto          = '';
                this.vdescproduto        = '';
                this.vund                = '';
                this.vqtditem            = 1;
                this.vvlunitario         = 0;
                this.vvldesconto         = 0;
                this.vvltotal            = 0;
                this.vvfrete             = 0;
                this.vvseg               = 0;
                this.vvoutro             = 0;
                this.vidncm              = null;
                this.vidcest             = null;
                this.vidcfop             = null;
                this.vorig               = '0';
                this.valiquotaibpt       = 0; 
                this.vregime             = '0';
                this.vcst                = '00'; 
                this.vcstpiscofins       = '1';
                this.vcstipi             = '9';                              
                this.vppis               = 0;
                this.vvpis               = 0;
                this.vppisst             = 0;
                this.vvpisst             = 0;
                this.vpcofins            = 0;
                this.vvcofins            = 0;
                this.vpcofinsst          = 0;
                this.vvcofinsst          = 0;
                this.vpipi               = 0;
                this.vvipi               = 0;
                this.vcenq               = '99';
                this.vinfadprod          = '';
                this.vxped               = '';
                this.vnitemped           = '';                
                this.lstcamposicms       = [];
                /// partilha de icms 
                this.vbcufdest           = 0;   
                this.vpfcpufdedt         = 0; 
                this.vpicmsufdest        = 0;
                this.vpicmsinter         = 0;
                this.vpimsinterpart      = 0;
                this.vfcpufdest          = 0;
                this.vicmsufdest         = 0;
                this.vicmsufremet        = 0;  
                
                $('#cbncm').val(null).trigger('change');
                $('#cbcest').val(null).trigger('change');
                $('#cbcfop').val(null).trigger('change');
                $('.nav-tabs a[href="#dvicms"]').tab('show');
			},
			mtdadcionaritem(){
                if (this.vidfilial === null){
					this.$toastr.w('Selecione uma filial antes de lançar os ítens na nota!', 'Atenção!');
					$('#cbfilial').focus();
					return;                    
                }
                this.mtdlimparedicaoitem();
				this.vopitem					= 1;
				$('#mdedicaoitem').modal('show');
			},
            mtdalteraregime(){
                this.atribuilistacst(this.mtdselecionarcamposgrupofiscal);
            },
            atribuilistacst(callback){
                if (parseInt(this.vregime) === 0){
                    this.lstcst = this.cstnormal;
                    this.vcst   = '00';
                }else{
                    this.lstcst = this.cstsimples;
                    this.vcst   = '101';
                }
                callback();
            },
            mtdselecionarcamposgrupofiscal(){
                var vself       = this;
                if (parseInt(vself.vopitem) === 1){
                    let loader      = this.$loading.show();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'camposgrupofiscal'},
                        {parametro: 'idgrupo',      valor : vself.vcst}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {                    
                        vself.lstcamposicms = response.data;
                        loader.hide();           
                    }).catch(function (response) {
                        vself.lstcamposicms = [];                    
                        loader.hide();
                    });                
                }else{
                    if (vself.vcstold !== vself.vcst){
                        let loader      = this.$loading.show();
                        let parametros  = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'camposgrupofiscal'},
                            {parametro: 'idgrupo',      valor : vself.vcst}
                        ];
                        let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                        retorno.then(function (response) {                    
                            vself.lstcamposicms = response.data;
                            loader.hide();           
                        }).catch(function (response) {
                            vself.lstcamposicms = [];                    
                            loader.hide();
                        });                
                    }else{
                        vself.lstcamposicms = vself.lstcamposicmsold;
                    }
                }
            },
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
                        {parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
                        {parametro: 'offset',           valor : 0},
                        {parametro: 'idfilialclasse',   valor : vself.vidfilial}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            vself.mtdachouproduto(response, util.setfocus('#eddescproduto'));//callback para o foco
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidproduto').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    this.mtdlimparedicaoitem();
                    //this.mtdalteraregime();
				}
            },
            mtdachouproduto(response, callback){
                let vself = this;
                let produto = response.data[0];							
                vself.vidproduto			= produto.id;
                vself.vdescproduto 	        = produto.descricao;
                vself.vund      			= produto.und;
                vself.vvlunitario			= produto.tabelas[0].prtabela;
                vself.vidncm                = produto.idncm;
                vself.vidcest               = produto.idcest;
                vself.vorig                 = produto.origemproduto;                              

                var defncm = new Option(produto.descncm, vself.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change'); 							

                if (vself.vidcest !== null && vself.vidcest !== ''){
                    var defcest = new Option(produto.desccest, vself.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');                
                }else{
                    $('#cbcest').val(null).trigger('change'); 
                }                
                vself.mtddefineclasse(produto.classenf[0]);                
            },
			mtdselecionarclasse(){
                let vself        = this;
                vself.lstclasses = [];
				if (this.vcoddig === ''){
					vself.$toastr.w('O item deve ser informado!', 'Informação!');
					$('#edidproduto').focus();
					return;
                }				
                let loader      = vself.$loading.show();
                let filtro      = '';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 99999999999},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstclasses = response.data;
                    $('#mdselecionarclasse').modal('show');
                }).catch(function (response) {
                    loader.hide();
                });                				
            },
            mtddefineclasse(classe){
                let vself = this;
                vself.lstcamposicms       = [];
                vself.vidcfop             = classe.idcfop;
                vself.vregime             = classe.regime;
                vself.mtdalteraregime();
                vself.vcst                = classe.cst; 
                vself.vcstpiscofins       = classe.cstpiscofins;
                vself.vcstipi             = classe.cstipi;                              
                vself.vppis               = classe.ppis;
                vself.vppisst             = classe.ppisst;
                vself.vpcofins            = classe.pcofins;
                vself.vpcofinsst          = classe.pcofinsst;
                vself.vpipi               = classe.pipi;
                vself.vcenq               = classe.cenq;
                ///partilha de icms
                vself.vbcufdest           = classe.vbcufdest;
                vself.vpfcpufdedt         = classe.vpfcpufdedt;  
                vself.vpicmsufdest        = classe.vpicmsufdest;
                vself.vpicmsinter         = classe.vpicmsinter;
                vself.vpimsinterpart      = classe.vpimsinterpart;
                vself.vfcpufdest          = classe.vfcpufdest;
                vself.vicmsufdest         = classe.vicmsufdest;
                vself.vicmsufremet        = classe.vicmsufremet;
               
                var defcfop = new Option(classe.desccfop, vself.vidcfop, true, true);
                $('#cbcfop').append(defcfop).trigger('change'); 

                setTimeout(function(){
                    vself.lstcamposicms       = classe.lstcampos;
                    let qtd = vself.vqtditem;
                    vself.vqtditem = 0;
                    vself.vqtditem = qtd;
                    vself.mtdcalculatotalitem();
                }, 500);
                $('#mdselecionarclasse').modal('hide');
            },
            mtdgravaritem(){
                let vself = this;
				if (vself.vcoddig === ''){
					vself.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidproduto').focus();
					return;
                }
				if (vself.vdescproduto === ''){
					vself.$toastr.w('Descrição do produto deve ser informada!', 'Atenção!');
					$('#eddescproduto').focus();
					return;
                }
				if (vself.vund === ''){
					vself.$toastr.w('Unidade do produto deve ser informada!', 'Atenção!');
					$('#edund').focus();
					return;
				}
				if (parseFloat(vself.vqtditem) <= 0){
					vself.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditem').focus();
					return;
				}
				if (parseFloat(vself.vvlunitario) <= 0){
					vself.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
					$('#edvlunitario').focus();
					return;
                }
                if (vself.vidncm === null || vself.vidncm === ''){
					vself.$toastr.w('NCM do produto deve ser informado!', 'Atenção!');
					$('#cbncm').select2('open');
					return;
                }
                if (vself.vidcfop === null || vself.vidcfop === ''){
					vself.$toastr.w('CFOP deve ser informado!', 'Atenção!');
					$('#cbcfop').select2('open');
					return;
				} 
                if (vself.vcst === null || vself.vcst === ''){
					vself.$toastr.w(parseInt(vself.vregime) === 0 ? 'Código da situação tributária deve ser informado!' : 'CSOSN deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvicms"]').tab('show');
					$('#cbcst').focus();
					return;
				}                          
                if (vself.vcstpiscofins === null || vself.vcstpiscofins === ''){
					vself.$toastr.w('CST do PIS/COFINS deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvpiscofins"]').tab('show');
					$('#cbcstpiscofins').focus();
					return;
				}   
                if (vself.vcstipi === null || vself.vcstipi === ''){
					vself.$toastr.w('CST do IPI deve ser informado!', 'Atenção!');
                    $('.nav-tabs a[href="#dvipi"]').tab('show');
					$('#cbcstipi').focus();
					return;
				}                                                                              
				if (parseInt(vself.vopitem) === 1){
					if (util.findValInArray(vself.lstitensnf, 'idproduto', vself.vidproduto)){
						// vself.$toastr.w('Item já lançado na nota!', 'Atenção!');
						// $('#edidproduto').focus();
                        // return;
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'O ítem já está incluso na nota. Deseja continuar e adicioná-lo novamente?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'nao',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                sim: {
                                    text: '<u>S</u>im',
                                    keys: ['s', 'S'],
                                    btnClass: 'btn-blue',
                                    action: function () {  
                                        vself.vitem++; 
                                        let descncm = $('#cbncm').select2('data')[0]['text'];
                                        let desccfop= $('#cbcfop').select2('data')[0]['text'];
                                        let desccest= vself.vidcest !== null && vself.vidcest !== '' ? $('#cbcest').select2('data')[0]['text'] : ''                                        
                                        let itemtmp = {
                                            idproduto       : vself.vidproduto,
                                            item            : vself.vitem,
                                            coddig          : vself.vcoddig,
                                            descproduto     : vself.vdescproduto,
                                            und             : vself.vund,
                                            idncm           : vself.vidncm,
                                            descncm         : descncm,
                                            idcest          : vself.vidcest,
                                            desccest        : desccest,
                                            idcfop          : vself.vidcfop,
                                            desccfop        : desccfop,
                                            vlunitario      : vself.vvlunitario,
                                            qtditem         : vself.vqtditem,
                                            vldesconto      : vself.vvldesconto,
                                            vltotal         : vself.vvltotal,
                                            regime          : vself.vregime,
                                            orig            : vself.vorig,                        
                                            cst             : vself.vcst,
                                            cstpiscofins    : vself.vcstpiscofins,
                                            cstipi          : vself.vcstipi,
                                            ppis            : vself.vppis,
                                            vpis            : vself.vvpis,
                                            ppisst          : vself.vppisst,
                                            vpisst          : vself.vvpisst,
                                            pcofins         : vself.vpcofins,
                                            vcofins         : vself.vvcofins,
                                            pcofinsst       : vself.vpcofinsst,
                                            vcofinsst       : vself.vvcofinsst,
                                            pipi            : vself.vpipi,
                                            vipi            : vself.vvipi,
                                            cenq            : vself.vcenq,
                                            vtottrib        : util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round'),//verificar a possibilidade de geração do campo somente na geração do xml
                                            vfrete          : vself.vvfrete,
                                            vseg            : vself.vvseg,
                                            voutro          : vself.vvoutro,
                                            infadprod       : vself.vinfadprod,
                                            xped            : vself.vxped,
                                            nitemped        : vself.vnitemped,
                                            campos          : vself.lstcamposicms       
                                        };
                                        vself.lstitensnf.push(itemtmp);
                                        vself.mtdlimparedicaoitem();
                                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                                        $('#edidproduto').focus();
                                        vself.mtdtotalizarnota();                                                                        
                                    },
                                },
                                nao: {
                                    text: '<u>N</u>ão',
                                    keys: ['n', 'N'],
                                    action: function () {
                                        $('#edqtditem').focus();
                                    }
                                }
                            }
                        });                                
                    }else{
                        vself.vitem++; 
                        let descncm = $('#cbncm').select2('data')[0]['text'];
                        let desccfop= $('#cbcfop').select2('data')[0]['text'];
                        let desccest= vself.vidcest !== null && vself.vidcest !== '' ? $('#cbcest').select2('data')[0]['text'] : ''
                        let itemtmp = {
                            idproduto       : vself.vidproduto,
                            item            : vself.vitem,
                            coddig          : vself.vcoddig,
                            descproduto     : vself.vdescproduto,
                            und             : vself.vund,
                            idncm           : vself.vidncm,
                            descncm         : descncm,
                            idcest          : vself.vidcest,
                            desccest        : desccest,
                            idcfop          : vself.vidcfop,
                            desccfop        : desccfop,
                            vlunitario      : vself.vvlunitario,
                            qtditem         : vself.vqtditem,
                            vldesconto      : vself.vvldesconto,
                            vltotal         : vself.vvltotal,
                            regime          : vself.vregime,
                            orig            : vself.vorig,                        
                            cst             : vself.vcst,
                            cstpiscofins    : vself.vcstpiscofins,
                            cstipi          : vself.vcstipi,
                            ppis            : vself.vppis,
                            vpis            : vself.vvpis,
                            ppisst          : vself.vppisst,
                            vpisst          : vself.vvpisst,
                            pcofins         : vself.vpcofins,
                            vcofins         : vself.vvcofins,
                            pcofinsst       : vself.vpcofinsst,
                            vcofinsst       : vself.vvcofinsst,
                            pipi            : vself.vpipi,
                            vipi            : vself.vvipi,
                            cenq            : vself.vcenq,
                            vtottrib        : util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round'),//verificar a possibilidade de geração do campo somente na geração do xml
                            vfrete          : vself.vvfrete,
                            vseg            : vself.vvseg,
                            ///partilha de icms
                            vbcufdest       : vself.vbcufdest,
                            vpfcpufdedt     : vself.vpfcpufdedt,
                            vpicmsufdest    : vself.vpicmsufdest,
                            vpicmsinter     : vself.vpicmsinter,
                            vpimsinterpart  : vself.vpimsinterpart,
                            vfcpufdest      : vself.vfcpufdest,
                            vicmsufdest     : vself.vicmsufdest,
                            vicmsufremet    : vself.vicmsufremet,
                            ////////////////////////////////////////////
                            voutro          : vself.vvoutro,
                            infadprod       : vself.vinfadprod,
                            xped            : vself.vxped,
                            nitemped        : vself.vnitemped,                            
                            campos          : vself.lstcamposicms       
                        };
                        vself.lstitensnf.push(itemtmp);                        
                        vself.mtdlimparedicaoitem();
                        vself.atribuilistacst(vself.mtdselecionarcamposgrupofiscal);
                        $('#edidproduto').focus();
                        vself.mtdtotalizarnota();
                    }                   
                }else{
                    let i 		    = util.getArrayIndexForKey(this.lstitensnf, 'item', vself.vitemalt);
                    this.lstitensnf[i].descproduto     = vself.vdescproduto;
                    this.lstitensnf[i].und             = vself.vund;
                    this.lstitensnf[i].idncm           = vself.vidncm;
                    this.lstitensnf[i].descncm         = $('#cbncm').select2('data')[0]['text'];
                    this.lstitensnf[i].idcest          = vself.vidcest;
                    this.lstitensnf[i].desccest        = vself.vidcest !== null ? $('#cbcest').select2('data')[0]['text'] : '';
                    this.lstitensnf[i].idcfop          = vself.vidcfop;
                    this.lstitensnf[i].desccfop        = $('#cbcfop').select2('data')[0]['text'];
                    this.lstitensnf[i].vlunitario      = vself.vvlunitario;
                    this.lstitensnf[i].qtditem         = vself.vqtditem;
                    this.lstitensnf[i].vldesconto      = vself.vvldesconto;
                    this.lstitensnf[i].vltotal         = vself.vvltotal;
                    this.lstitensnf[i].regime          = vself.vregime;
                    this.lstitensnf[i].orig            = vself.vorig;
                    this.lstitensnf[i].cst             = vself.vcst;
                    this.lstitensnf[i].cstpiscofins    = vself.vcstpiscofins;
                    this.lstitensnf[i].cstipi          = vself.vcstipi;
                    this.lstitensnf[i].ppis            = vself.vppis;
                    this.lstitensnf[i].vpis            = vself.vvpis;
                    this.lstitensnf[i].ppisst          = vself.vppisst;
                    this.lstitensnf[i].vpisst          = vself.vvpisst;
                    this.lstitensnf[i].pcofins         = vself.vpcofins;
                    this.lstitensnf[i].vcofins         = vself.vvcofins;
                    this.lstitensnf[i].pcofinsst       = vself.vpcofinsst;
                    this.lstitensnf[i].vcofinsst       = vself.vvcofinsst;
                    this.lstitensnf[i].pipi            = vself.vpipi;
                    this.lstitensnf[i].vipi            = vself.vvipi;
                    this.lstitensnf[i].cenq            = vself.vcenq;
                    ///partilha de icms
                    this.lstitensnf[i].vbcufdest       = vself.vbcufdest;
                    this.lstitensnf[i].vpfcpufdedt     = vself.vpfcpufdedt;
                    this.lstitensnf[i].vpicmsufdest    = vself.vpicmsufdest;
                    this.lstitensnf[i].vpicmsinter     = vself.vpicmsinter;
                    this.lstitensnf[i].vpimsinterpart  = vself.vpimsinterpart;
                    this.lstitensnf[i].vfcpufdest      = vself.vfcpufdest;
                    this.lstitensnf[i].vicmsufdest     = vself.vicmsufdest;
                    this.lstitensnf[i].vicmsufremet    = vself.vicmsufremet;
                    ////////////////////////

                    this.lstitensnf[i].vtottrib        = util.arredondaValores(parseFloat(vself.valiquotaibpt) * parseFloat(vself.vvltotal) / 100, 2, 'round');//verificar a possibilidade de geração do campo somente na geração do xml
                    this.lstitensnf[i].vfrete          = vself.vvfrete;
                    this.lstitensnf[i].vseg            = vself.vvseg;
                    this.lstitensnf[i].voutro          = vself.vvoutro;
                    this.lstitensnf[i].infadprod       = vself.vinfadprod;
                    this.lstitensnf[i].xped            = vself.vxped;
                    this.lstitensnf[i].nitemped        = vself.vnitemped;
                    this.lstitensnf[i].campos          = vself.lstcamposicms;                                      
                    $('#mdedicaoitem').modal('hide');                        
                    this.mtdtotalizarnota(); 
                }                
            },
            mtdalteraritem(item){
                console.log('');
                let vself = this;                  
                vself.vopitem             = 2;
                vself.vitemalt            = item.item;
                vself.vcoddig             = item.coddig;
                vself.vidproduto          = item.idproduto;
                vself.vdescproduto        = item.descproduto;
                vself.vund                = item.und;
                vself.vqtditem            = item.qtditem;
                vself.vvlunitario         = item.vlunitario;
                vself.vvldesconto         = item.vldesconto;
                vself.vvltotal            = item.vltotal;
                vself.vvfrete             = item.vfrete;
                vself.vvseg               = item.vseg;
                vself.vvoutro             = item.voutro;
                vself.vidncm              = item.idncm;
                vself.vidcest             = item.idcest;
                vself.vidcfop             = item.idcfop;
                vself.vorig               = item.orig;                  
                vself.vregime             = item.regime;
                //// partilha de icms 
                vself.vbcufdest           = item.vbcufdest;
                vself.vpfcpufdedt         = item.vpfcpufdedt;
                vself.vpicmsufdest        = item.vpicmsufdest;
                vself.vpicmsinter         = item.vpicmsinter;
                vself.vpimsinterpart      = item.vpimsinterpart;
                vself.vfcpufdest          = item.vfcpufdest;
                vself.vicmsufdest         = item.vicmsufdest;
                vself.vicmsufremet        = item.vicmsufremet;
                ///////////////////////////////////////////////

                if (parseInt(vself.vregime) === 0){
                    vself.lstcst = vself.cstnormal;
                }else{
                    vself.lstcst = vself.cstsimples;
                }                

                vself.vcst                = item.cst; 
                vself.vcstold             = item.cst;
                vself.vcstpiscofins       = item.cstpiscofins;
                vself.vcstipi             = item.cstipi;                              
                vself.vppis               = item.ppis;
                vself.vvpis               = item.vpis;
                vself.vppisst             = item.ppisst;
                vself.vvpisst             = item.vpisst;
                vself.vpcofins            = item.pcofins;
                vself.vvcofins            = item.vcofins;
                vself.vpcofinsst          = item.pcofinsst;
                vself.vvcofinsst          = item.vcofinsst;
                vself.vpipi               = item.pipi;
                vself.vvipi               = item.vipi;
                vself.vcenq               = item.cenq;
                vself.vinfadprod          = item.infadprod;
                vself.vxped               = item.xped;
                vself.vnitemped           = item.nitemped;                    
                                
                var defncm  = new Option(item.descncm, vself.vidncm, true, true);
                $('#cbncm').append(defncm).trigger('change');

                if (vself.vidcest !== null){
                var defcest  = new Option(item.desccest, vself.vidcest, true, true);
                    $('#cbcest').append(defcest).trigger('change');                
                }else{
                    $('#cbcest').val(null).trigger('change');
                }             

                var defcfop  = new Option(item.desccfop, vself.vidcfop, true, true);
                $('#cbcfop').append(defcfop).trigger('change'); 
                                                
                this.lstcamposicms       = JSON.parse(JSON.stringify(item.campos));
                this.lstcamposicmsold    = JSON.parse(JSON.stringify(item.campos));

                $('#mdedicaoitem').modal('show');
            },
            mtdexcluiritem(item){
                if (parseInt(this.opcrud) < 3){  
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitensnf, 'item', item.item);
                    this.lstitensnf.splice(indiceitem, 1); 
                    this.mtdtotalizarnota(); 
                }              
            },
            mtdadicionarinfcpl(){                
                var vself       = this;
                if (vself.vidinfcpl !== null){    
                    let loader      = vself.$loading.show();
                    let filtro      = ' and id='+vself.vidinfcpl;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadinformacoescomplementares.php');
                    retorno.then(function (response) {
                        loader.hide();                        
                        vself.vinfcpl = vself.vinfcpl === '' ? response.data[0].conteudo : vself.vinfcpl +'\n'+ response.data[0].conteudo;
                        $('#cbinfcpl').val(null).trigger('change');
                    }).catch(function (response) {
                        loader.hide();
                    });
                }             
            },
            mtdnotasref(){
                this.vtiponfref  = 0;
                this.vchavenfref = '';
                $('#mdnotaref').modal('show');
            },
            mtdadicionarnotaref(){                
                if (this.vchavenfref === ''){
                    this.$toastr.w('Chave de acesso deve ser informada!', 'Atenção!');
                    util.setfocus('#edchavenfref');
                    return;                    
                }

                this.vchavenfref = this.vchavenfref.replace(/[^\d]+/g,'');

                if (this.vchavenfref.length < 44){
                    this.$toastr.w('Chave de acesso deve ter 44 caracteres!', 'Atenção!');
                    util.setfocus('#edchavenfref');
                    return;                    
                }                
                if (util.findValInArray(this.lstnotasref, 'chave', this.vchavenfref)){
                    this.$toastr.w('Chave já lançada na nota!', 'Atenção!');
                    $('#edchavenfref').focus();
                    return;
                }                
                let nfreftmp = {
                    tipo : this.vtiponfref,
                    chave:  this.vchavenfref.replace(/[^\d]+/g,'')
                };
                this.lstnotasref.push(nfreftmp);
                $('#mdnotaref').modal('hide'); 
            },
            mtddeletarnotaref(index){
                this.lstnotasref.splice(index, 1);
            },
            mtdincluirparcelacobranca(){
                this.vdvenc  = util.DataAtual(true);
                this.vvdup   = 0;
                $('#mdcobranca').modal('show');
            },
            mtdgravarparcela(){
                if (this.vdvenc === null){
                    this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
                    util.setfocus('#eddvenc');
                    return;                    
                }
                if (parseFloat(this.vvdup) <= 0){
                    this.$toastr.w('Valor da parcela inválido!', 'Atenção!');
                    util.setfocus('#edvdup');
                    return;                    
                }
                let parcelatmp = {
                    ndup  : '',
                    dordem: new Date(util.formatardataDB (this.vdvenc)),
                    dvenc : this.vdvenc,
                    vdup  : this.vvdup
                };
                this.lstcobranca.push(parcelatmp);
                this.mtdordenarparcelas();
                $('#mdcobranca').modal('hide');
            },
            mtddeletarparcela(index){
                this.lstcobranca.splice(index, 1);
                this.mtdordenarparcelas();
            },            
            mtdordenarparcelas(){
                this.lstcobranca.sort(function(a,b) {
                    return a.dordem < b.dordem ? -1 : a.dordem > b.dordem ? 1 : 0;
                });
                this.vtotalcobranca     = 0;
                for (let i = 0; i < this.lstcobranca.length; i++) {
                    this.lstcobranca[i].ndup = i + 1;            
                    this.vtotalcobranca     = this.vtotalcobranca + parseFloat(this.lstcobranca[i].vdup);
                } 
            },
            mtdincluirformadepagamento(){
                this.vidforma       = null;
                this.vvpag          = 0;
                this.vcaut          = '';                
                $('#cbformapagamento').val(null).trigger('change');
                $('#mdformapagamento').modal('show');
            }, 
            mtdgravarformapagamento(){
                if (this.vidforma === null){
                    this.$toastr.w('Forma de pagamento deve ser informada!', 'Atenção!');
                    util.setfocus('#cbformapagamento');
                    return;                    
                }
                if (this.vvpag <= 0){
                    this.$toastr.w('Valor informado é inválido!', 'Atenção!');
                    util.setfocus('#edvpag');
                    return;                    
                }                 
                if (util.findValInArray(this.lstformaspagamento, 'idforma', this.vidforma)){
                    this.$toastr.w('Forma de pagamento já lançada na nota!', 'Atenção!');
                    $('#cbformapagamento').focus();
                    return;
                }                                
                let formatmp = {
                    idforma     : this.vidforma,
                    descforma   : this.formaselecionada.descricao,
                    vpag        : this.vvpag,
                    indpag      : parseInt(this.formaselecionada.tipo) !== 1 ? 0 : 1,
                    tpag        : this.formaselecionada.indicefiscal,
                    tpintegra   : parseInt(this.formaselecionada.tef) === 0 ? 2 : 1,
                    tband       : this.formaselecionada.indicefiscalband === null ? '' : this.formaselecionada.indicefiscalband,
                    cnpj        : this.formaselecionada.cnpjband === null ? '' : this.formaselecionada.cnpjband,
                    caut        : parseInt(this.formaselecionada.tef) === 0 ? '' : this.vcaut
                };
                this.lstformaspagamento.push(formatmp);
                this.mtdtotalizaformaspagamento();
                this.mtdincluirformadepagamento();
                util.setfocus('#cbformapagamento');
            },
            mtdtotalizaformaspagamento(){
                this.vtotalformas     = 0;
                for (let i = 0; i < this.lstformaspagamento.length; i++) {
                    this.vtotalformas     = this.vtotalformas + parseFloat(this.lstformaspagamento[i].vpag);
                }                 
            },
            mtddeletarforma(index){
                this.lstformaspagamento.splice(index, 1);
                this.mtdtotalizaformaspagamento();
            },
            mtdincluirvolumefrete(){
                this.vqvol      = 0;
                this.vesp       = '';
                this.vmarca     = '';
                this.vnvol      = '';
                this.vpesol     = 0;
                this.vpesob     = 0;
                this.lstlacres  = [];
                this.vnlacre    = '';
                $('#mdvolumefrete').modal('show');                
            },
            mtdgravarvolumefrete(){
                if (parseFloat(this.vqvol) <= 0){
                    this.$toastr.w('Quantidade de volumes deve ser informada!', 'Atenção!');
                    util.setfocus('#edqvol');
                    return;                    
                }
                if (this.vesp === ''){
                    this.$toastr.w('Espécie deve ser informada!', 'Atenção!');
                    util.setfocus('#edesp');
                    return;                    
                }
                if (this.vmarca === ''){
                    this.$toastr.w('Marca deve ser informada!', 'Atenção!');
                    util.setfocus('#edmarca');
                    return;                    
                }
                if (this.vnvol === ''){
                    this.$toastr.w('Numeração dos volumes deve ser informada!', 'Atenção!');
                    util.setfocus('#ednvol');
                    return;                    
                }                
                if (parseFloat(this.vpesol) <= 0){
                    this.$toastr.w('Peso líquido inválido!', 'Atenção!');
                    util.setfocus('#edpesol');
                    return;                    
                }
                if (parseFloat(this.vpesob) <= 0){
                    this.$toastr.w('Peso bruto inválido', 'Atenção!');
                    util.setfocus('#edpesob');
                    return;                    
                }                                
                if (this.lstlacres.length === 0){
                    this.$toastr.w('Ao menos um lacre deve ser informado!', 'Atenção!');
                    util.setfocus('#ednlacre');
                    return; 
                }                
                let volumetmp = {
                    item    : 1,
                    qvol    : this.vnvol,
                    esp     : this.vesp,
                    marca   : this.vmarca,
                    nvol    : this.vnvol,
                    pesol   : this.vpesol,
                    pesob   : this.vpesob,
                    lacres  : this.lstlacres
                };
                this.lstvolumes.push(volumetmp);
                this.mtdordenarvolumes();
                $('#mdvolumefrete').modal('hide');
            },
            mtddeletarvolume(index){
                this.lstvolumes.splice(index, 1);
                this.mtdordenarvolumes();
            },            
            mtdordenarvolumes(){
                this.lstvolumes.sort(function(a,b) {
                    return a.item < b.item ? -1 : a.item > b.item ? 1 : 0;
                });
                for (let i = 0; i < this.lstvolumes.length; i++) {
                    this.lstvolumes[i].item = i + 1;            
                } 
            },
            mtdincluirlacre(){
                if (this.vnlacre === ''){
                    this.$toastr.w('Número do lacre deve ser informado!', 'Atenção!');
                    util.setfocus('#ednlacre');
                    return;                    
                }
                if (util.findValInArray(this.lstlacres, 'nlacre', this.vnlacre)){
                    this.$toastr.w('Número do lacre já lançado para o volume!', 'Atenção!');
                    $('#ednlacre').focus();
                    return;
                }                                
                let lacretmp = {
                    nlacre     : this.vnlacre
                };
                this.lstlacres.push(lacretmp);
                this.vnlacre = '';
                $('#ednlacre').focus();
            },
            mtddeletarlacre(index){
                this.lstlacres.splice(index, 1);
            },
            mtdtotalizarnota(){
                this.tbc 			    = 0; this.ticms 		    = 0;
                this.ticmsdeson 	    = 0; this.tfcp 			    = 0;
                this.tbcst 		        = 0; this.tst 			    = 0;
                this.tfcpst 		    = 0; this.tfcpstret 	    = 0;
                this.tprod 		        = 0; this.tfrete 		    = 0;
                this.tseg 			    = 0; this.tdesc 		    = 0;
                this.tii 			    = 0; this.tipi 			    = 0;
                this.tipidevol 	        = 0; this.tpis 			    = 0;
                this.tcofins 		    = 0; this.toutro 		    = 0;
                this.tnf 			    = 0; this.ttottrib 		    = 0;                 

                for (let i = 0; i < this.lstitensnf.length; i++) {
                    for (let campo of this.lstitensnf[i].campos) {
                        if (campo.idcampo === 'vBC'){
                            this.tbc = this.tbc + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vICMS'){
                            this.ticms = this.ticms + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vBCST'){
                            this.tbcst = this.tbcst + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vICMSST'){
                            this.tst = this.tst + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vII'){
                            this.tii = this.tii + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vICMSDeson'){
                            this.ticmsdeson = this.ticmsdeson + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCP'){
                            this.tfcp = this.tfcp + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCPST'){
                            this.tfcpst = this.tfcpst + parseFloat(campo.valor);
                        }
                        if (campo.idcampo === 'vFCPSTRet'){
                            this.tfcpstret = this.tfcpstret + parseFloat(campo.valor);
                        }                                                                                                
                    }                     
                    this.tprod      = this.tprod    + this.lstitensnf[i].vltotal + this.lstitensnf[i].vldesconto;                                       
                    this.tipi       = this.tipi     + util.arredondaValores(parseFloat(this.lstitensnf[i].vipi), 2, 'round');
                    this.tpis       = this.tpis     + util.arredondaValores(parseFloat(this.lstitensnf[i].vpis), 2, 'round');
                    this.tcofins    = this.tcofins  + util.arredondaValores(parseFloat(this.lstitensnf[i].vcofins), 2, 'round');
                    this.toutro     = this.toutro   + util.arredondaValores(parseFloat(this.lstitensnf[i].voutro), 2, 'round');
                    this.tfrete     = this.tfrete   + util.arredondaValores(parseFloat(this.lstitensnf[i].vfrete), 2, 'round');
                    this.tseg       = this.tseg     + util.arredondaValores(parseFloat(this.lstitensnf[i].vseg), 2, 'round');
                    this.tdesc      = this.tdesc    + this.lstitensnf[i].vldesconto;

                    this.tnf        = this.tprod - this.tdesc + this.tst + this.tfrete + this.tseg + this.toutro + this.tii + this.tipi;
                    this.ttottrib   = util.arredondaValores(parseFloat(this.ttottrib) + parseFloat(this.lstitensnf[i].vtottrib), 2, 'round');                    
                }
            },
            mtdalteravalorcampoicms(campo, valor){
                for (let i = 0; i < this.lstcamposicms.length; i++) {
                    if (this.lstcamposicms[i].idcampo === campo){
                       this.lstcamposicms[i].valor = valor; 
                    }
                }
            },
            mtdpegavalorcampoicms(campo){
                let $vret = 0;
                for (let i = 0; i < this.lstcamposicms.length; i++) {
                    if (this.lstcamposicms[i].idcampo === campo){
                       $vret = this.lstcamposicms[i].valor;
                       break;
                    }
                }
                return $vret;
            },
            mtdenviar(nf){
				$('#mdmenunf').modal('hide');
                //if (!util.opcaousuario('020Z.010Z.065Z', this.$store.state.perfilusuario)){
                //    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                //}else{
                    let vself  = this;
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'enviarnf'},
                        {parametro: 'idnf',     	valor : nf.id},
                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                        {parametro: 'codop',        valor : '020Z.010Z.065Z'}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Nota enviada com sucesso!', 'Informação!');
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }
                        }
                        $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                        vself.pnnf          = nf.nnf;
                        vself.pidfilial     = nf.idfilial;
                        var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, '');                            
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                //}				
            },
            mtdconsultarnf(nf){
                $('#mdmenunf').modal('hide');
                if (parseInt(nf.situacaonota) === 4){
                    this.$toastr.i('Operação não permitida para NF denegada!', 'Informação!');
                    return;
                }                
                if (nf.chave === '' || nf.chave === null){
                    this.$toastr.w('Chave de acesso não disponível para consulta!', 'Informação!');
                    return;
                }
                //if (!util.opcaousuario('', this.$store.state.perfilusuario)){
                //    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                //}else{
                    let vself  = this;
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'consultarnf'},
                        {parametro: 'idnf',     	valor : nf.id},
                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                        {parametro: 'codop',        valor : ''}//verificar depois o perfil
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if ($.isNumeric(response.data)){
                            vself.$toastr.s('Consulta realizada com sucesso!', 'Informação!');
                        }else{
                            let tpret = response.data.substring(0,1);
                            switch (tpret) {
                                case 'I':
                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                    break;
                                case 'E': default:
                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                    break;
                            }
                        }
                        $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                        vself.pnnf          = nf.nnf;
                        vself.pidfilial     = nf.idfilial;
                        var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, '');                            
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });
                //}				
            },            
            mtdconfirmacaocancelamento(nf){
                let vself = this;
                if (vself.vjustcancelamento.length < 15){
                    vself.$toastr.w('Motivo do cancelamento de ter no mínimo 15 caracteres!', 'Informação!');
                    $('#txtcancelanf').focus();
                    return;
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma CANCELAMENTO da Nota Fiscal?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    vself.mtdcancelarnf(nf);
                                }, 200);                                 
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {  
                                $('#txtcancelanf').focus();                              
                            }
                        }
                    }
                });             
            },
            mtdcancelarnf(nf){
				$('#mdmenunf').modal('hide');
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'cancelarnf'},
                    {parametro: 'idnf',     	valor : nf.id},
                    {parametro: 'xjust',     	valor : vself.vjustcancelamento},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.010Z.065Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota CANCELADA com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                    vself.pnnf          = nf.nnf;
                    vself.pidfilial     = nf.idfilial;
                    var deffilial       = new Option(nf.fantasiafil, nf.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotasfiscais(1, '');                            
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });			
            },
            mtdimprimir(nf){
				$('#mdmenunf').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idnf='+nf.id+'&docimp=danfe', '_blank');
            },
            mtdcartacorrecao(id){
                $('#mdmenunf').modal('hide');
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and nf.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
					if (parseInt(response.data.notas[0].situacaonota) !== 2){
						vself.$toastr.i('Para emissão de carta de correção a nota fiscal deve estar autorizada!', 'Informação!');
						return;
					}
                    vself.nfcartacorrecao = response.data.notas[0];
                    vself.lstcartas       = vself.nfcartacorrecao.cartascorrecao;
                    $('#mdcartacorrecao').modal('show');
                }).catch(function (response) {
                    loader.hide();
                });                              
            },
            mtdcancelaredicaocartacorrecao(){
                $('#dvedicaocarta').hide();
                $('#dvlistacartas').fadeIn(700);                                 
            },
            mtdincluircarta(){
                if (util.findValInArray(this.lstcartas, 'situacaocc', 0)){
                    this.$toastr.i('Existe uma carta de correção pendente de envio. Verifique antes de incluir outra!', 'Atenção!');
                    return;                    
                }
                if (this.lstcartas.length >= 20){
                    this.$toastr.i('A quantidade de cartas de correção para a NF selecionada, já atingiu o máximo permitido. Impossível incluir uma nova!', 'Atenção!');
                    return;
                }
                this.opcarta          = 1;  
                this.titcartacorrecao = 'INCLUSÃO DE CARTA DE CORREÇÃO';
                this.vdthremissaocarta= util.DataAtual(true);
                this.vnseqevento      = '';  
                this.vconteudocarta   = '';
                $('#dvlistacartas').hide();
                $('#dvedicaocarta').fadeIn(700);                                 
                util.setfocus('#txtconteudocarta');
            },
            mtdalterarcarta(carta){
                if (parseInt(carta.situacaocc) === 1){
                    this.$toastr.w('Carta já enviada para SEFAZ. Impossível alterar!', 'Atenção!');
                    return;
                }                 
                this.opcarta          = 2;  
                this.titcartacorrecao = 'ALTERAÇÃO DE CARTA DE CORREÇÃO';
                this.vdthremissaocarta= util.DataAtual(true);
                this.vnseqevento      = carta.nseqevento;  
                this.vconteudocarta   = carta.xcorrecao;
                $('#dvlistacartas').hide();
                $('#dvedicaocarta').fadeIn(700);                                 
                util.setfocus('#txtconteudocarta');                
            },
            mtdgravarcartacorrecao(){
                let vself = this;
                if (vself.vconteudocarta.length < 15){
                    vself.$toastr.w('O texto da carta de correção deve ter no mínimo 15 caracteres!', 'Atenção!');
                    util.setfocus('#txtconteudocarta');
                    return;
                }
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : parseInt(vself.opcarta) === 1 ? 'incluircc' : 'alterarcc'},
                    {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                    {parametro: 'nseqevento',   valor : vself.vnseqevento},                        
                    {parametro: 'xcorrecao', 	valor : vself.vconteudocarta},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(vself.opcarta) === 1 ? 'GERAR PERFIL INCLUSAO' : 'GERAR PERFIL ALTERACAO'},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.lstcartas = response.data.cartascorrecao;
                        vself.$toastr.s('Carta processada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
                vself.mtdcancelaredicaocartacorrecao();
            },
            mtddeletarcarta(carta){
                let vself = this;
                if (parseInt(carta.situacaocc) === 1){
                    vself.$toastr.w('Carta já enviada para SEFAZ. Impossível excluir!', 'Atenção!');
                    return;
                }                
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'excluircc'},
                    {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                    {parametro: 'nseqevento',   valor : carta.nseqevento},                        
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : 'GERAR PERFIL EXCLUSAO'},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.lstcartas = response.data.cartascorrecao;
                        vself.$toastr.s('Carta excluída com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdenviarcarta(carta){
                let vself   = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma envio da carta de correção?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    let loader  = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'enviarcc'},
                                        {parametro: 'idnotafiscal', valor : vself.nfcartacorrecao.id},
                                        {parametro: 'nseqevento',   valor : carta.nseqevento},                        
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : 'GERAR PERFIL ENVIO'},
                                    ];                    
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data.inf)){
                                            vself.lstcartas = response.data.cartascorrecao;
                                            vself.$toastr.s('Carta enviada com sucesso!', 'Informação!');
                                        }else{
                                            let tpret = response.data.inf.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                }, 200);                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdimprimircarta(carta){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idnf='+this.nfcartacorrecao.id+'&sqe='+carta.nseqevento+'&docimp=cce', '_blank');
            },
            mtdinutilizacao(){
                this.iidfilial           = null;
                this.idthremissao        = util.DataAtual(true);
                this.inmodelo            = '55';
                this.inserie             = '';
                this.inini               = '';
                this.infim               = '';
                this.ixjust              = '';  
                $('#cbfilialinutilizacao').val(null).trigger('change');              
                $('#mdinutilizacao').modal('show');
            },
            mtdconfirmarinutilizacao(){
                let vself   = this;
                if (vself.ixjust.length < 15){
                    vself.$toastr.w('O motivo da inutilização deve ter no mínimo 15 caracteres!', 'Atenção!');
                    util.setfocus('#txtmotivoinutilizacao');
                    return;
                }
                if (vself.iidfilial === null){
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    util.setfocus('#cbfilialinutilizacao');
                    return;
                }                
                if (vself.inserie === ''){
                    vself.$toastr.w('Série deve ser informada!', 'Atenção!');
                    util.setfocus('#edserieinutilizacao');
                    return;
                }
                if (vself.inini === ''){
                    vself.$toastr.w('Número inicial deve ser informado!', 'Atenção!');
                    util.setfocus('#ednini');
                    return;
                }
                if (vself.infim === ''){
                    vself.$toastr.w('Número final deve ser informado!', 'Atenção!');
                    util.setfocus('#ednfim');
                    return;
                } 
                if (parseInt(vself.infim) - parseInt(vself.inini) > 10000){
                    vself.$toastr.w('Faixa de inutilização não pode ultrapassar 10.000!', 'Atenção!');
                    util.setfocus('#ednini');
                    return;
                }                                                              
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma inutilização da faixa informada?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){
                                    let loader  = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',                   valor : 'inutilizar'},
                                        {parametro: 'iidfilial',            valor : vself.iidfilial},
                                        {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'nmodelo',              valor : vself.inmodelo},
                                        {parametro: 'nserie',               valor : parseInt(vself.inserie)},
                                        {parametro: 'nini',                 valor : parseInt(vself.inini)},
                                        {parametro: 'nfim',                 valor : parseInt(vself.infim)},
                                        {parametro: 'xjust',                valor : vself.ixjust},
                                        {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',            valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',                valor : 'GERAR PERFIL ENVIO'},
                                    ];                    
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                    retorno.then(function (response) {
                                        loader.hide();                                        
                                        if ($.isNumeric(response.data.inf)){
                                            $('#mdinutilizacao').modal('hide');
                                            vself.$toastr.s('Inutilização enviada com sucesso!', 'Informação!');

                                            $('.selectpicker').selectpicker('val', ['5']);
                                            vself.pnnf          = '';
                                            vself.pdestinatario = '';
                                            vself.pmodelo       = 99;
                                            vself.pserie        = '';
                                            vself.pidfilial     = vself.iidfilial;
                                            vself.pfiltroperiodo= 1;
                                            vself.pdtini        = vself.idthremissao;
                                            vself.pdttim        = vself.idthremissao;
                                            var deffilial       = new Option($('#cbfilialinutilizacao').select2('data')[0]['text'], vself.pidfilial, true, true);
                                            $('#cbfilialpesq').append(deffilial).trigger('change');

                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcarreganotasfiscais(1, '');                                            
                                        }else{
                                            let tpret = response.data.inf.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                }, 200);                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#cbfilialinutilizacao').focus();
                            }
                        }
                    }
                });                
            },
            mtdconsultarstatus(){
                let vself = this;
                let loader  = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'consultarstatus'},
                    {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente}
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();                                        
                    let tpret = response.data.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.s(response.data.substring(4), 'Informação!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.substring(4), 'Erro!');
                            break;
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdsalvarxmls(){
                let vself = this;
                let dtini = '';
                let dtfim = '';
                let filtrofil = '';
                let filtrofili = '';

                if(this.vidfilialexport!==null){
                    filtrofil = ' and nf.idfilial= '+this.vidfilialexport+' ';
                    filtrofili = ' and i.idfilial= '+this.vidfilialexport+' ';
                }

                if(this.vespecificarperiodo){
                    dtini   = util.InverterData(vself.pdtinixml);
                    dtfim   = util.InverterData(vself.pdtfimxml);
                }else{
                   var database = new Date(parseInt(this.anoselect), parseInt(this.messelect), 10)
                   let retdatas =  util.pri_ult_diames(database, true);
                   dtini   = util.InverterData(retdatas.primeirodiames);
                   dtfim   = util.InverterData(retdatas.ultimodiames);
                }
                let periodo = ' and nf.situacaonota in (2,3,4,5) and nf.dthremissao between "' + dtini + ' 00:00:00" and "' + dtfim + ' 23:59:59" '+filtrofil;
                let periodoi = ' and i.dthremissao between "' + dtini + ' 00:00:00" and "' + dtfim + ' 23:59:59" '+filtrofili;
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Serão salvos apenas os xmls das notas em situação <span class="badge badge-primary bdg-autorizada">Autorizada</span>, '+
                                '<span class="badge badge-primary bdg-cancelada">Cancelada</span>, '+
                                '<span class="badge badge-primary bdg-denegada">Denegada</span> e as '+
                                '<span class="badge badge-primary bdg-inutilizada">Inutilizações</span>. '+
                                'Deseja mesmo continuar?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    setTimeout(function(){  
                                        let loader  = vself.$loading.show();
                                        let parametros = [];
                                        
                                        if (!vself.mtdvisualizainut()){
                                            parametros      = [
                                            {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                                            {parametro: 'op',                   valor : 'salvarxmlsnew'},
                                            {parametro: 'filtro',               valor : periodo},
                                            {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil}
                                        ];
                                        }else{
                                            parametros      = [
                                            {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                                            {parametro: 'op',                   valor : 'salvarxmlsnew'},
                                            {parametro: 'filtro',               valor : periodo},
                                            {parametro: 'filtroinutilizadas',   valor : periodoi},
                                            {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil}
                                        ];
                                        }
                                      
                                        
                                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                                        retorno.then(function (response) {
                                            loader.hide(); 
                                            if ($.isNumeric(response.data.inf)){
                                                //rotina para o download do arquivo
                                                window.open(vself.$store.state.configpaths.pathcontrole+response.data.pathdownload, '_blank');
                                                $('#mdexportxml').modal('hide');
                                            }else{      
                                                let tpret = response.data.inf.substring(0,1);
                                                switch (tpret) {
                                                    case 'I':
                                                        vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                                        break;
                                                    case 'E': 
                                                        vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                                        break;
                                                }                                                                             
                                            }
                                        }).catch(function (response) {
                                            loader.hide();
                                            vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                        });                               
                                    }, 200);                                
                                }
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                            
            },
            mtdsalvarxmlindividual(idnota){
                let vself = this;
                $('#mdmenunf').modal('hide');                                
                let inutilizacoes = [];
                let notas = [];
                notas.push(idnota);                                
                if (notas.length > 0){
                    let loader  = vself.$loading.show();
                    let conteudogerar = {
                        'notas'         : notas,
                        'inutilizacoes' : inutilizacoes
                    }
                    let parametros      = [
                        {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',                   valor : 'salvarxmls'},
                        {parametro: 'conteudogerar',        valor : JSON.stringify(conteudogerar)},
                        {parametro: 'idfilial',             valor : vself.$store.state.filialpadrao.codfil}
                    ];                    
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                    retorno.then(function (response) {
                        loader.hide(); 
                        if ($.isNumeric(response.data.inf)){
                            //rotina para o download do arquivo
                            window.open(vself.$store.state.configpaths.pathcontrole+response.data.pathdownload, '_blank');
                        }else{                                                                                   
                            vself.$toastr.e(response.data.inf, 'Erro!');
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    });                               
                }                
            },
            mtdcfopparatodos(){
                if (this.lstitensnf.length > 0){
                    $('#cbcfoptodos').val(null).trigger('change');
                    $('#mdatribuircfop').modal('show');
                }
            },
            mtdatribuircfop(){
                let vself = this;
                if (vself.vidcfoptodos === null){
                   vself.$toastr.w('Informe o CFOP para atribuição!', 'Atenção!');
                   $('#cbcfoptodos').select2('open'); 
                   return;
                }
                for (let i = 0; i < vself.lstitensnf.length; i++) {
                    vself.lstitensnf[i].idcfop   = vself.vidcfoptodos;
                    vself.lstitensnf[i].desccfop = $('#cbcfoptodos').select2('data')[0]['text'];                                        
                }
                vself.$toastr.s('CFOP atribuido com sucesso!', 'Informação!');
                $('#mdatribuircfop').modal('hide');
            },
            mtdverificamudancamodelo(){
                let vself = this;
                if (parseInt(vself.opcrud) === 2){
                    if (parseInt(vself.vmodelo) !== vself.vmodelo_old){
                        vself.mtdcarregaultnf();
                    }
                }                
            },
            mtdinfemailcliente(nf){ 
                $('#mdmenunf').modal('hide');
                this.idnfemailenviar = nf.id;
                this.emailenviar     = nf.email;
                $('#mdinfemailcliente').modal('show');
            },
            mtdenviardocsnfcliente(idnf){
                let vself = this;
                if (vself.emailenviar === ''){
                    vself.$toastr.w('E-mail deve ser informado!', 'Atenção!');
                    $('#edinfemailcliente').focus();
                    return;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',                   valor : 'enviardocsnfcliente'},
                    {parametro: 'idnf',                 valor : vself.idnfemailenviar},
                    {parametro: 'emailenviar',          valor : vself.emailenviar},
                ];                    
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide(); 
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('E-mail enviado com sucesso!', 'Informação!');
                        $('#mdinfemailcliente').modal('hide');
                    }else{                                                                                   
                        vself.$toastr.e(response.data, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdcalculatotalitem(){
                console.log('');
                this.vvltotal   = this.vqtditem * this.vvlunitario - this.vvldesconto;                

                this.vvpis      = this.vvltotal * this.vppis / 100;

                this.vvpisst    = this.vvltotal * this.vppisst / 100;

                this.vvcofins   = this.vvltotal * this.vpcofins / 100;

                this.vvcofinsst = this.vvltotal * this.vpcofinsst / 100;

                this.vvipi      = this.vvltotal * this.vpipi / 100;

                this.vtottrib   = util.arredondaValores(parseFloat(this.vvltotal) * parseFloat(this.valiquotaibpt) / 100, 2, 'round');


                let vlmvast = 0;
                let vbcst   = 0;
                let vlbcicmsst = 0;
                let pmvast  = 0;
                let vlicms	= 0; 
                let vlicmsst= 0;
                let icmsst 	= 0;
                let picmsst = 0;

                for (let i = 0; i < this.lstcamposicms.length; i++) {
                    //descomentei para viabilizar o cálculo da substituição tribuitária
                    if (this.lstcamposicms[i].idcampo === 'pICMS'){
                        if (parseFloat(this.lstcamposicms[i].valor) > 0){
                            if (parseFloat(this.mtdpegavalorcampoicms('pRedBC')) === 0){//adicionei para separar o calculo da substituição
                                this.mtdalteravalorcampoicms('vBC', this.vvltotal);
                            }
                        }
                    }
                    ////////////////////////////////////////////////////////////////////


                    if (this.lstcamposicms[i].idcampo === 'vICMS'){
                        vlicms   	= parseFloat(this.mtdpegavalorcampoicms('pICMS')) * parseFloat(this.mtdpegavalorcampoicms('vBC')) / 100;
                        this.lstcamposicms[i].valor = vlicms;
                    }

                    if (this.lstcamposicms[i].idcampo === 'pRedBC'){
                        if(parseFloat(this.mtdpegavalorcampoicms('pRedBC')) != 0 ){ // adicionei para resolver a redução do bcicms - by guga
                                var predbc =  parseFloat(this.mtdpegavalorcampoicms('pRedBC')) /100
                                var bcicms =  parseFloat(this.mtdpegavalorcampoicms('vBC'))
                                var vlred  =  bcicms * predbc
                                var vlbase = parseFloat(this.mtdpegavalorcampoicms('vBC')) - vlred
                                this.mtdalteravalorcampoicms('vBC', vlbase); // guga
                        }
                    }

                    if (this.lstcamposicms[i].idcampo === 'pMVAST'){                        
                        if (parseFloat(this.lstcamposicms[i].valor) > 0){
                            pmvast 		= parseFloat(this.lstcamposicms[i].valor);
                            vlmvast  	= (parseFloat(this.vvltotal) + parseFloat(this.vvipi)) * parseFloat(pmvast) / 100;
                            picmsst     = parseFloat(this.mtdpegavalorcampoicms('pICMSST'));                            
                            vlbcicmsst  = parseFloat(this.vvltotal)   + parseFloat(this.vvipi) + vlmvast;                            
                            this.mtdalteravalorcampoicms('vBCST', vlbcicmsst);                            
                            icmsst 	    = vlbcicmsst * picmsst / 100;
                            vlicmsst	= icmsst - vlicms;
                        }
                    }

                    if (this.lstcamposicms[i].idcampo === 'vICMSST'){
                        this.lstcamposicms[i].valor = parseFloat(vlicmsst);
                    }

                    if (this.lstcamposicms[i].idcampo === 'pFCP'){
                        if (parseFloat(this.lstcamposicms[i].valor) > 0){
                            this.mtdalteravalorcampoicms('vBCFCP', this.vvltotal);
                        }
                    }
                    if (this.lstcamposicms[i].idcampo === 'vFCP'){
                        this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('pFCP')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCP')) / 100;
                    }
                    if (this.lstcamposicms[i].idcampo === 'pFCPST'){
                        if (parseFloat(this.lstcamposicms[i].valor) > 0){
                            this.mtdalteravalorcampoicms('vBCFCPST', this.vvltotal);
                        }
                    }
                    if (this.lstcamposicms[i].idcampo === 'vFCPST'){
                        this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('pFCPST')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCPST')) / 100;
                    }
                    if (this.lstcamposicms[i].idcampo === 'pFCPSTRet'){
                        if (parseFloat(this.lstcamposicms[i].valor) > 0){
                            this.mtdalteravalorcampoicms('vBCFCPSTRet', this.vvltotal);
                        }
                    }
                    if (this.lstcamposicms[i].idcampo === 'vFCPSTRet'){
                        this.lstcamposicms[i].valor = parseFloat(this.mtdpegavalorcampoicms('vBCFCPSTRet')) * parseFloat(this.mtdpegavalorcampoicms('vBCFCPST')) / 100;
                    }                                                                                                                        
                }                
            },
            mtdrotinacorrecaonf(nf){
                $('#mdmenunf').modal('hide'); 
                if (!util.opcaousuario('020Z.020Z.100Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    this.cnfcorrecao = nf;
                    this.cchavenf    = '';
                    this.clayoutxml  = '';
                    $('#mdcorrecaonf').modal('show');
                }
            },
            mtdconfirmacorrecaonf(){
                let vself = this;
                if (vself.cchavenf === ''){
                    vself.$toastr.w('Chave deve ser informada!', 'Atenção!');    
                    $('#edcchavenf').focus();
                    return;
                }
                if (vself.clayoutxml === ''){
                    vself.$toastr.w('Layout do xml deve ser informado!', 'Atenção!');    
                    $('#txclayoutxml').focus();
                    return;
                }                    
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma correção da NF?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                setTimeout(function(){                                
                                    vself.mtdgravarcorrecaonf();
                                }, 200); 
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });                
            },
            mtdgravarcorrecaonf(){
                let vself  = this;
                $('#mdcorrecaonf').modal('hide');
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'correcaonf'},
                    {parametro: 'idnf',     	valor : vself.cnfcorrecao.id},
                    {parametro: 'nnf',     	    valor : vself.cnfcorrecao.nnf},
                    {parametro: 'filialnf',     valor : vself.cnfcorrecao.idfilial},
                    {parametro: 'serie',     	valor : vself.cnfcorrecao.serie},
                    {parametro: 'modelo',     	valor : vself.cnfcorrecao.modelo},
                    {parametro: 'chave',     	valor : vself.cchavenf},
                    {parametro: 'layoutxml',    valor : vself.clayoutxml},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.020Z.100Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadnotasfiscais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Correção realizada com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                    vself.pnnf          = vself.cnfcorrecao.nnf;
                    vself.pidfilial     = vself.cnfcorrecao.idfilial;
                    var deffilial       = new Option(vself.cnfcorrecao.fantasiafil, vself.cnfcorrecao.idfilial, true, true);
                    $('#cbfilialpesq').append(deffilial).trigger('change');
                    vself.pqtd_paginas  = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarreganotasfiscais(1, '');                            
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdmarcartodos(){
                util.marcartodas(this.lstpedidosagrupar, 'selecionado');
            },
            mtdhabilita(index){
                util.habilita(this.lstpedidosagrupar, 'selecionado', index);
            },            
            mtdagruparpedidosnf(){
                if (!util.opcaousuario('020Z.020Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    $('#mdagruparpedidos').modal('show');
                }
            },
            mtdconfirmaagrupamento(){
                let vself = this;

                if (vself.aidfilialnf === null){
                    vself.$toastr.w('Filial para geração da NF deve ser informada!', 'Atenção!');
                    $('#cbfilialnf').select2('open');
                    return;                    
                }

                let temselecionado = false;
                for (let i = 0; i < vself.lstpedidosagrupar.length; i++) {
                    if (parseInt(vself.lstpedidosagrupar[i].selecionado) === 1){
                        temselecionado = true;
                        break;
                    }
                }
                if (!temselecionado){
                    vself.$toastr.w('Selecione ao menos um pedido para geração da NF!', 'Atenção!');
                    return;
                }                

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma inclusão da NF dos pedidos agrupados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdgerarnfagrupada();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });                                
            },
            mtdgerarnfagrupada(){
                let vself   = this;
                let loader  = vself.$loading.show();

                let pedidos = '';
                for (let i = 0; i < vself.lstpedidosagrupar.length; i++) {
                    if (parseInt(vself.lstpedidosagrupar[i].selecionado) === 1){
                        pedidos = pedidos+', '+vself.lstpedidosagrupar[i].id;
                    }
                }

                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gerarnfagrupada'},
                    {parametro: 'pedidos',     	valor : pedidos.substring(2)},
                    {parametro: 'modelo',     	valor : vself.amodelo},
                    {parametro: 'idfilialnf',   valor : vself.aidfilialnf},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.020Z.040Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota gerada com sucesso!', 'Informação!');
                        $('.selectpicker').selectpicker('val', ['0','1','2','3','4']);
                        vself.pconteudo             = '';
                        vself.pqtd_paginas          = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarreganotasfiscais(1, ' and nf.id='+response.data);                        
                        $('#mdagruparpedidos').modal('hide');
                    }else{
                        $('#mdagruparpedidos').modal('hide');
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                                
            },
			mtddetalhespedido(idpedido){
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},       
            mtdfiltropesquisapedgr(){
                let rfiltro = '';
                //Filtra somente os faturados
                rfiltro = rfiltro + ' and p.stpedido=1 and p.idnotafiscal=0';

				if (this.aidfilial !== ''){
					rfiltro = rfiltro + ' and p.idfilial='+this.aidfilial;
				}
				if (this.aidcliente !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.aidcliente;
				}

    			rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.adtini) + '" and "' + util.InverterData(this.adtfim) + '"';

                return rfiltro;
            },            
            mtdpesquisarpedidosagr(){
                let vself = this;
                if (vself.aidfilial === null){
                    vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
                    $('#cbfilialagr').select2('open');
                    return;
                }                
                if (vself.aidcliente === null){
                    vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                    $('#cbclienteagr').select2('open');
                    return;
                }
                let loader      = this.$loading.show();
				let filtro          = vself.mtdfiltropesquisapedgr();
                let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : '99999999999'},
                        {parametro: 'offset',       valor : '0'}
                    ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    vself.lstpedidosagrupar = [];
                    let lstmp = response.data.pedidos;                    
                    for (let i = 0; i < lstmp.length; i++) {
                        lstmp[i].selecionado = 0;                        
                    }
                    vself.lstpedidosagrupar = JSON.parse(JSON.stringify(lstmp));
                    loader.hide();											
                }).catch(function (response) {
                    vself.lstpedidosagrupar = [];
                    loader.hide();
                });
            }                                    
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op',           valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario',    valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.alterafilialnf			= util.opcaousuario('020Z.010Z.068Z', vself.$store.state.perfilusuario);
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('020Z.020Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

                // rotinas exportxmls - guga
                
                let dataAtual = new Date();
                let mesatual  = dataAtual.getMonth();
                this.anoAtual = dataAtual.getFullYear();
                
                this.anoselect = parseInt(this.anoAtual);
                this.messelect = parseInt(mesatual);

 
                for (let index = 0; index < 20; index++) {// cria uma lista de anos a partir da data atual - guga
                    if(index===0){
                        this.anoslista[index] = parseInt(this.anoAtual)
                    }else{
                        this.anoslista[index] = this.anoslista[index - 1] - 1;
                    }
                }



            }
        },
        computed:{
            validou() {
                return this.vidfilial === null || this.viddestinatario === null || this.vnatope === '' || this.lstitensnf.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            
            verificalibera() {
                if (this.opcrud !== 2) {
                    if(util.opcaousuario('020Z.020Z', this.$store.state.perfilusuario)){
                        return true;
                    }
                }
                    return false;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarreganotasfiscais(val, '');
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddig = val;
					this.mtdlocalizarproduto(this.vcoddig);					
                }
			},            
        }
    }
</script>
<style>    
	.def-col-opcoes-nf{
		width: 70px !important;
	}   
    .def-col-nnf, .def-col-modelo, .def-col-serie{
        width: 80px !important;
    }
    .def-col-nnf{
        font-weight: bold;
        color: #6c757d!important;
    }
    .def-col-valor{
        font-weight: bold !important;
        color: #6c757d!important;
        width: 100px !important;
    }
    .def-col-dthremissao{
        width: 150px !important;
    }
    .def-col-situacaonota{
        width: 100px !important;
    }
    .def-col-xmotivo{
       width: 300px !important; 
    }
    .def-col-chave{
        width: 300px !important; 
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-enviada{
        background: #EEA435!important;
        color: white;
    }
    .bdg-autorizada{
        background: #5A956A!important;
    }
    .bdg-cancelada{
        background: #cc330d!important;
    }
    .bdg-denegada{
        background: #7a240e!important;
    }
    .bdg-inutilizada{
        background: #6c757d!important;
    }
    .lbllacre{
        font-size: 10px;
    }
    .lstdettot{
        color: #666666!important;
        font-weight: bold;
        padding: 5px!important;
    }
    .bdg-totais{
        position: relative!important;
        float: right!important;
        font-size: 12px!important;
        width: 100px!important;
        text-align: right!important;
    }
    #tittotalizadores{        
        font-weight: bold;
        margin-bottom: 0px;
        font-size: 14px;        
    }
    #pcondusucarta{
        background: #f7f7f7;
        text-indent: 1.5em;
        padding: 15px;
        border: 1px solid #ced4da;
        border-radius: 5px;        
    }
    #tblistainut .thead-dark th {
        color: #cccccc!important;
    }
</style>